import { TitleInsuranceType, MortgageType, TitleSearchType, PurchaserType, VendorType, PersonType, RegistrationType, FinanceType, PriorOwnerType, DepositType, PayeeType, MortgageSummaryType, RegistrationSummaryType, TitleInsuranceSummaryType, PurchaserSummaryType, ThirdPartySummaryType, MortgageSolicitorType, ContactType } from "./SideDrawer/sideTypes";
import { XMLNode } from "./fileToolbar/fileToolbarTypes";
import { runInnerFunction } from "./compatManager";
import { PopupPageId } from "./Components/navigationTypes";
import { MakeLegalStart } from "./util/rpwPropertyFuncs";
import { SetXML } from "../../libs/transformation/src/setXML";
import xmlMap from '../../libs/transformation/lib/xmlMap.json';
import { DocumentSavingPreferenceType } from './Components/clientportal/types';
import { DefectUndertakingType, UndertakingItemType } from "./Components/Undertaking/UndertakingFuncs";

export type XMLJSON = {
    name: string;
    attributes: Record<string, string>,
    children: Array<XMLJSON>,
    value: string,
}

export function getDRDataReader(dataRoot: Element): DRDataReader {
    // dxd todo: might need another datareader for subdivision
    return new DRDataReader(dataRoot);
}

export function getDataReader(dataRoot: Element): RPWDataReader {
    const appcode = dataRoot?.getAttribute("ApplicationSubCode") ? dataRoot?.getAttribute("ApplicationSubCode") : "ON";
    var ret = null;
    switch (appcode.toUpperCase()) {
        case "MB":
            ret = new MBDataReader(dataRoot);
            break;
        case "BC":
            ret = new BCDataReader(dataRoot);
            break;
        case "NS":
            ret = new NSDatareader(dataRoot);
            break;
        case "SK":
            ret = new SKDataReader(dataRoot);
            break;
        case "AB":
            ret = new ABDataReader(dataRoot);
            break;
        case "ON":
        default:
            ret = new ONDataReader(dataRoot);
            break;
    }
    return ret;
}

export async function fetchDataRoot(id: string, sessionID: string): Promise<XMLDocument> {
    let url = 'http://localhost/rplus/ON/getxml.asp?lfdata=1&tb=TPAppXML&id=' + id + '&SessionID=' + sessionID;
    return await new Promise(resolve => {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function () {
            resolve(xhr.responseXML);
        };
        xhr.onerror = function () {
            resolve(undefined);
            console.error("** An error occurred during the XMLHttpRequest");
        };
        xhr.send();
    })
}

function convertXMLtoJSON(xmlData: Element): XMLJSON {
    const attributes = Array.from(xmlData.attributes);
    let record: Record<string, string> = {};
    attributes.forEach(element => {
        record[element.nodeName] = element.nodeValue
    });
    let childrenXML: Array<Element> = Array.from(xmlData.childNodes as NodeListOf<Element>);
    let children: Array<XMLJSON> = childrenXML.map(convertXMLtoJSON)
    return {
        name: xmlData.tagName,
        attributes: record,
        children: children,
        value: xmlData.nodeValue,
    }
}

function parseFullName(fullname: string): Array<string> {
    const arrNames = ["", "", ""];	//first, middle, last
    if (!(fullname > ''))	//nothing to parse
        return arrNames;

    //now let's parse
    let surname = "", givennames = "";
    let posComa = fullname.indexOf(",");
    if (posComa != -1) {
        surname = fullname.substring(0, posComa);
        givennames = fullname.substring(posComa + 1);
    }
    else {
        let posSpace = fullname.lastIndexOf(" ");
        if (posSpace != -1) {
            givennames = fullname.substring(0, posSpace);
            surname = fullname.substring(posSpace + 1);
        }
        else {
            surname = "";
            givennames = fullname;	//not even a proper name, like people from Mongolia
        }
    }
    arrNames[2] = (surname).trim();
    let fn = "", mn = "";
    givennames = (givennames).trim();
    givennames = givennames.replace(/ {2}/g, " ");
    let arrgivennames = givennames.split(" ");
    for (let i = 0; i < arrgivennames.length; i++) {
        let onename = (arrgivennames[i]).trim();
        if (fn == "")
            fn = onename;
        else {
            if (mn != "")
                mn += " ";
            mn += onename;
        }
    }
    arrNames[0] = fn;
    arrNames[1] = mn;

    return arrNames;
}
export interface RPWDataReader {
    setNoteMainScreenName(category: string, index: number): void;
    setNotesCheckmark(index: number): void;
    getCheckmarkVal(index:number): boolean;
    getFirmIncludedEmail(): string;
    getParsedName(getter: string): { firstname: string, middlename: string, lastname: string },
    getOtherAttribute(type: string): string,
    setOtherAttribute(type: string, value: string): void,
    getAppCode(): string,
    getDashboardFields(): any;
    setDashboardIsDirty(): void;
    getClientContactInfo(province: string, skip?: boolean): any;
    getClientEmail(): any;
    getFirmName(): any;
    getUserNames(province: string): any,
    getBuyerPeopleInfo(): Array<PurchaserType>;
    getSellerPeopleInfo(): Array<VendorType>;
    getVendorInformation(): Array<Record<string, string>>;
    getThirdPartyInfo(): Array<PersonType>;
    getRealEstateAgent(): any;
    getPurchaserRealEstateAgent(): any;
    getTitleSearch(): Array<TitleSearchType>;
    getMortgageInformation(): Array<MortgageType>;
    getDefectMortgages(): Array<MortgageType>;
    getRegistrationDetails(): Array<RegistrationType>;
    getInsuranceInformation(): TitleInsuranceType;
    getFinancialInformation(): FinanceType;
    getDefectInformation(): Array<Record<string, string>>;
    getContractInformation(): { closingDate: Date, propertyAddress: string };
    getPSM(): 'P' | 'S' | 'M' | 'O' | '',
    getPSMDummy(): string,
    getClosingDate(): string,
    getDocumentMergeDate(): string[],
    getDocumentSignCheckBox():string[],
    getClientConnectId(): string,
    getXMLList(type: string): any,
    getLawyerId(): string,
    getLanguage(): string, 
    getActingForLenderOnly(): string,
    getPurchaseMoneyMortgage(): string,
    getMortgagorInformation(): Array<PurchaserType>,
    getMortgagorName(): string,
    getLawyerName(): string,
    getOtherSideLawyerName(): string,
    getBorrowerSideLawyerName(): string,
    getOtherSideLawyerFirmName():string
    getOtherSideLawyerField(field: string): string,
    otherSideLawyerIsNotary(): boolean,
    getOtherSideLawyerBadge(): string,
    getVendorLawyerName(): string,
    getVendorLawyerField(field: string): string,
    setDashboardFieldsNotDirty();
    setDashboardFieldsDirty(name: string);
    setVTB(): void,
    setEstate(nodeType: string, pos: number): boolean,
    setOtherPartyType(pos: number, value: string): void,
    setCorporation(nodeType: string, pos: number): boolean,
    setIndividual(nodeType: string, pos: number): boolean,
    exclusiveAppendNodes(type: string, nodes: any[]),
    deleteNode(type: string, index: number),
    deleteReplySubNodes(index: number, parentIndex: number),
    moveNodeUp(type: string, index: number),
    moveNodeDown(type: string, index: number),
    getMainNoteInformation(): Array<XMLJSON>,
    getTPAppXMLNode(): Array<XMLJSON>,
    getNodeInformation(string): Array<XMLJSON>,
    getFileNumber(): string,
    setFileNumber(fileNumber: string): void,
    getReline(): string,
    getPropertyAddress(): string,
    getCoordinates(): {lat: number, lng: number},
    setCoordinates(lat: number, lng: number): void,
    getUnitType(): string,
    getUnitNumber(): string,
    getStreetNumber(): string,
    getStreetNumberSuffix(): string,
    getStreetName(): string,
    getPostalCode(): string,
    getCity(): string,
    getMunicipality(): string,
    getPropertyPin(): string,
    getFileType(): string,
    getFirmContact(): string,
    getFirmContactID(): string[],
    getLinkedAppID(): string,
    getMortgageNodesLength(): number,
    getExtraPropertyNodesLength(): number,
    getAppId(): string,
    getUserID(): string,
    getThirdPartyAccountAttribute(accountIdentificationString: string, targetAttribute: string): string,
    getPIPFormID(): string,
    setPIPFormID(pipform: string): void,
    setPIPConfirmnationNumber(confirmId: string): void,
    getPIPConfirmnationNumber(): string,
    getTransferInstrumentNumber(): string,
    setTransferInstrumentNumber(instrumentNumber: string): void,
    setTransferRegistrationDate(registrationDate: string): void,
    getRegistrationDate(): string,
    getRegistryOffice(): string,
    getCreateTransfer(): string,
    setCreateTransfer(createTransfer: string): void,
    setDockerId(dockerId: string): void,
    getDockerId(): string,
    setDockerName(dockerName: string): void,
    getDockerName(): string,
    setLRONumber(lroNumber: string): void,
    setTeraviewTransfer(transfer: string): void,
    setTeraviewTransferOption(transferOption: string): void,
    getResideAtProperty(): string,
    getPropertyType(): string,
    setPropertyType(val: string): void,
    getVendorAddress(): string,
    getbApplyToSpecificBuilding(): string,
    getBuildingNumToMerge(): string,
    getLRONumber(): string,
    getCreateCharge(): string,
    setCreateCharge(booleanStr: string): void,
    getCreateDischarge(): string,
    setCreateDischarge(booleanStr: string): void,
    getERegTransferType(): string,
    getDocumentGeneral(): Array<XMLNode>,
    getLawyerSaveMergeDocMode(): string,
    getDockerIdOverwriteFlag(): string,
    getDockerNameOverwriteFlag(): string,
    getCoditionalDate(): string,
    getClientName(): string,
    getClientNameSurnames(): string,
    getLawyerInitials(): string,
    getStaffInitials(): string,
    getNewHome(): string,
    setNewHome(newHome: string): void; 
    getInterimClosingDate(): string,
    getAdjustmentDate(): string,
    getEarlyPossessionDate(): string,
    getRequisionDate(): string,
    getConditionalUntilDate(): string,
    getRequisitionSentDate(): string,
    getReverseTrustLetterDate(): string,
    getRequisitionResponseDate(): string,
    getRequisitionReceivedDate(): string,
    getRegistryOfficeCode(): string,
    getGuarantorInfo(): Array<XMLNode>,
    getPriorOwnerInfo(): Array<PriorOwnerType>,
    getFileCreationDate(): string,
    getContractDate(): string,
    getLawyerReviewDate(): string, 
    getLawyerSoluno(): string,
    getContractPrice(): string,
    getIncludeHST(): string,
    setIncludeHST(val: string): void,
    getHSTAmount(): string,
    getAssessmentRollNo(): string,
    getDepositTotal(): string,
    getVIPInfoMsgID(): string,
    getVIPInfoProjName(): string,
    getVIPInfoSubFolder(): string,
    getVIPInfoPassCode(): string,
    setClosingDate(closingDate: string): void,
    setInterimClosingDate(closingDate: string): void,
    setContractDate(date: string): void,
    setContractPrice(price: string): void,
    getDeposits(): Array<DepositType>,
    setDeposits(deposits: any): void,
    getLegalDesc(): string,
    setLegalDesc(nodes: any): void,
    setBDOC(val: string): void,
    getTrustBank(): string,
    getTransitNumber(): string,
    getTrustNumber(): string,
    updateIntakeInformation(name: string, updatedVal: any): void,
    setLanguage(language: string): void,
    setFirmContactInfo(info: any, skipUpdateView?: boolean): void;
    getConsideration(): string,
    setConsideration(amount: string): void,
    getConsiderationEreg(): string,
    setConsiderationEreg(amount: string): void
    getTarionEnrolDate(): string,
    setTarionEnrolDate(enrolDate: string): void,
    getCondoCorpName(): string,
    getCondoCorpNumber(): string,
    getCondoCorpContactName(): string,
    getInterimBDOC(): string,
    setInterimBDOC(amount: string): void,
    addNewVendor(name: string): any,
    addNewPurchaser(name: string | null, type?: string): any,
    getSrcApp(): any,
    getStraightClosing(): string,
    getSolunoData(province: string): any,
    getSolunoDetailsIfPresent(): any,
    exportSolunoXSLT(): void,
    setSolunoItemExport(description: string): void;
    setHistoryItem(): void;
    setReplyTo(val: number): void;
    getReplyTo(): number;
    getAllLawyer(): Array<PersonType>;
    getAllOtherLawyer(): Array<PersonType>;
    getMortgageLenderName(): Array<string>;
    getAllPayees(): Array<PayeeType>;
    getAllMortgageSummary(): Array<MortgageSummaryType>;
    getRegistrationSummary(): Array<RegistrationSummaryType>;
    getTitleInsuranceSummary(): TitleInsuranceSummaryType;
    setFieldsFromRecord(record: Record<string, any>): void;
    getIncludeGSTInAccount(): string;
    getGSTObject(province?: string): any;
    getHSTApplicable(): string;
    setPID(PID: string): void;
    getPID(): string;
    getSpouseNotOnTitleInfo(): { SpouseName: string | null, SpouseEmail: string | null }[]
    setPurchaserAddress(address: string): void;
    setLastGmapAddressKey(address: string): void;
    getLastGmapAddressKey(): string;
    getExtraPropertiesAddress(): Array<string>; 
    getTitleSearchPinHistory(): Array<string>;
    getAllPins(): Array<string>;
    getPurchaserSummary(): Array<PurchaserSummaryType>;
    getVendorSummary(): Array<PurchaserSummaryType>;
    getMortgagerSummary(): Array<PurchaserSummaryType>;
    getFireInsuranceCompany(): string;
    getThirdPartySummary(): Array<ThirdPartySummaryType>;
    getWebFilings(): Array<string>;
    getLenderSolicitors(): Array<MortgageSolicitorType>;
    getContactPersons(): Array<ContactType>
    getDefectUndertakings(): Array<DefectUndertakingType>;
    setIsUseStandardDocumentsOverwite(): void;
    setIsUseWesternProtocolOverwite(): void;
    getUndertaking(): any[];
}

export class ONDataReader implements RPWDataReader {
    livedataRoot: Element;
    constructor(livedataRoot: Element) {
        this.livedataRoot = livedataRoot;
    }

    setNoteMainScreenName(category: string, index: number): void {
        const dataRoot = this.livedataRoot as any;
        const mainNote = dataRoot.selectNodes('MainNote')[dataRoot.selectNodes('MainNote').length - index - 1];
        mainNote.setAttribute("mainScreenName", category);
        runInnerFunction("SetPageDirty", null);
    }

    setNotesCheckmark(index: number): void {
        const dataRoot = this.livedataRoot as any;
        const mainNote = dataRoot.selectNodes('MainNote')[dataRoot.selectNodes('MainNote').length - index - 1];
        const currentCheckmarkStatus = mainNote.getAttribute('reactIsCheckMarked');
        const newCheckmarkStatus = currentCheckmarkStatus === '1' ? '0' : '1';
        mainNote.setAttribute('reactIsCheckMarked', newCheckmarkStatus);
        runInnerFunction("SetPageDirty", null);
    }
    getCheckmarkVal(index: number): boolean {
        const dataRoot = this.livedataRoot as any;
        const mainNote = dataRoot.selectNodes('MainNote')[dataRoot.selectNodes('MainNote').length - index - 1];
        const retVal = mainNote.getAttribute('reactIsCheckMarked');
        return (retVal === '1');
    }
    getSrcApp() {
        return this.livedataRoot.getAttribute("SrcApp");
    }
    getStraightClosing(): string {
        return this.livedataRoot.getAttribute("StraightClosing");
    }
    addNewVendor(name: string) {
        const newNode = this.livedataRoot.parentNode.ownerDocument.createElement("Vendor");
        newNode.setAttribute("IsVendor", "1");
        newNode.setAttribute("OnTitle", "1");
        newNode.setAttribute("Gender", "Corporation");
        newNode.setAttribute("Name", name)
        this.livedataRoot.appendChild(newNode);
        return newNode;
    }
    addNewPurchaser(name: string | null) {
        const newNode = this.livedataRoot.parentNode.ownerDocument.createElement("Purchaser");
        newNode.setAttribute("IsPurchaser", "1");
        newNode.setAttribute("OnTitle", "1");
        newNode.setAttribute("Name", name ?? "")
        this.livedataRoot.appendChild(newNode);
        return newNode;
    }
    getInterimBDOC(): string {
        return (this.livedataRoot as any).selectSingleNode("InterimAdjustment")?.getAttribute("InterimBDOC");
    }
    setInterimBDOC(amount: string): void {
        let livedataRoot = this.livedataRoot as any;
        const interimAdjustmentNode = (livedataRoot).selectSingleNode("InterimAdjustment");
        if (interimAdjustmentNode) {
            interimAdjustmentNode.setAttribute("InterimBDOC", amount);
        } else {
            // Create the InterimAdjustment node
            const newInterimAdjustmentNode = livedataRoot.ownerDocument.createElement("InterimAdjustment");
            newInterimAdjustmentNode.setAttribute("InterimBDOC", amount);
            livedataRoot.appendChild(newInterimAdjustmentNode);
        }
        runInnerFunction("SetPageDirty", null);
    }
    getCondoCorpName(): string {
        return this.livedataRoot.getAttribute("CondoCorp");
    }
    getCondoCorpNumber(): string {
        return this.livedataRoot.getAttribute("CondoCorpNumber");
    }
    getCondoCorpContactName(): string {
        return (this.livedataRoot as any).selectSingleNode("CondoContact")?.getAttribute("ContactName");
    }
    getTarionEnrolDate(): string {
        return this.livedataRoot.getAttribute("ONHWPRegistrationDate");
    }
    getConsideration(): string {
        return this.livedataRoot.getAttribute("ConsiderationAmount");
    }
    setConsideration(amount: string): void {
        this.livedataRoot.setAttribute("ConsiderationAmount", amount);
        this.livedataRoot.setAttribute("isConsiderationAmountOverWrite", "1");
        runInnerFunction("SetPageDirty", null);
    }
    getConsiderationEreg(): string {
        return (this.livedataRoot as any).selectSingleNode("LTT")?.getAttribute("LTTItem2f");
    }
    setConsiderationEreg(amount: string): void {
        (this.livedataRoot as any).selectSingleNode("LTT")?.setAttribute("LTTItem2f", amount);
        (this.livedataRoot as any).selectSingleNode("LTT")?.setAttribute("isLTTItem2fOverWrite", "1");
        runInnerFunction("SetPageDirty", null);
    }
    getDeposits(): Array<DepositType> {
        let deposits = this.getNodeInfo("Deposit").map(node => {
            let att = node.attributes;
            return {
                Amount: att.Amount,
            }
        }
        );
        let results = deposits.filter((deposit) => deposit.Amount > "");
        return results;
    }
    setHistoryItem(): void {
        // Get current date/time and user
        const currentDateTime = new Date().toLocaleString();
        const lawyer = (this.livedataRoot as any).selectSingleNode("lawyer");
        const username = lawyer ? lawyer.getAttribute("SubUsername") || "" : "";

        // Update main node attributes
        this.livedataRoot.setAttribute("LastModifiedDate", currentDateTime);
        this.livedataRoot.setAttribute("LastModifiedBy", username);

        // Get or create ModifyHistory node
        let histories = (this.livedataRoot as any).selectSingleNode("ModifyHistory");
        if (!histories) {
            const tmpNode = this.livedataRoot.ownerDocument.createElement("ModifyHistory");
            histories = this.livedataRoot.appendChild(tmpNode);
        }

        // Create new History entry
        const newHistoryNode = this.livedataRoot.ownerDocument.createElement("History");
        newHistoryNode.setAttribute("LastModifiedDate", currentDateTime);
        newHistoryNode.setAttribute("LastModifiedBy", username);
        newHistoryNode.setAttribute("Application", "Soluno");

        // Remove oldest entry if more than 10 entries exist
        const existingHistories = histories.selectNodes("History");
        if (existingHistories.length > 9) {
            histories.removeChild(existingHistories[9]);
        }

        // Insert new entry at the beginning
        if (histories.childNodes.length > 0) {
            histories.insertBefore(newHistoryNode, histories.childNodes[0]);
        } else {
            histories.appendChild(newHistoryNode);
        }

        runInnerFunction('SaveFile', true);
    }
    setBDOC(val: string): void {
        let adjustment = (this.livedataRoot as any).selectSingleNode("Adjustment");
        adjustment.setAttribute("BDOC", val);
        // let trust = (this.livedataRoot as any).selectSingleNode("Trust");
        // trust.setAttribute("BDOC", val);
        adjustment.setAttribute("isBDOCOverWrite", "1");
        runInnerFunction("SetPageDirty", null);
    }
    setLegalDesc(nodes: any): void {
        this.exclusiveAppendNodes("LegalDescriptionInput", nodes); 
        MakeLegalStart(this.livedataRoot);
        runInnerFunction("SetPageDirty", null);
    }
    setPropertyType(val: string): void {
        this.livedataRoot.setAttribute("PropertyType", val);
    }
    getLegalDesc(): string {
        const legalDesc = this.livedataRoot.getAttribute("LegalDescription");
        if (legalDesc === null) {
           MakeLegalStart(this.livedataRoot);
        }
        return this.livedataRoot.getAttribute("LegalDescription");
    }
    getPropertyCity(): string {
        return this.livedataRoot.getAttribute("City");
    }
    setClosingDate(closingDate: string): void {
        this.livedataRoot.setAttribute("ClosingDate", closingDate);
        runInnerFunction("SetPageDirty", null);
    }
    setTarionEnrolDate(enrolDate: string): void {
        this.livedataRoot.setAttribute("ONHWPRegistrationDate", enrolDate);
        runInnerFunction("SetPageDirty", null);
    }
    setInterimClosingDate(interimClosingDate: string): void {
        this.livedataRoot.setAttribute("InterimClosingDate", interimClosingDate);
        runInnerFunction("SetPageDirty", null);
    }
    setContractDate(date: string): void {
        this.livedataRoot.setAttribute("ContractDate", date);
        runInnerFunction("SetPageDirty", null);
    }
    setContractPrice(price: string): void {
        this.livedataRoot.setAttribute("PurchasePrice", price);
        runInnerFunction("SetPageDirty", null);
    }
    setDeposits(deposits: any): void {
        this.livedataRoot.setAttribute("depositDefaultBroker", "0");
        this.exclusiveAppendNodes("Deposit", deposits);
        this.setDepositTotalFromDeposit();
    }
    getFirmIncludedEmail(): string {
        var retVal = '';
        var dRoot = (this.livedataRoot as any);
        const staffNode = dRoot.selectSingleNode('Staff');
        const misc = staffNode.selectSingleNode('MiscContact');

        if (misc) {
            const contactMethod = misc.getAttribute('ContactMethod');
            const email = misc.getAttribute('ContactMethodInfo');
    
            if (contactMethod === 'Email') {
                (email) ? retVal = email : retVal = '';
            }
        } else {
            return null;
        }

        return retVal;
    }

    getParsedName(getter: string): { firstname: string, middlename: string, lastname: string } {
        const name = this[getter]();
        const parsedName = parseFullName(name);
        return {
            firstname: parsedName[0],
            middlename: parsedName[1],
            lastname: parsedName[2]
        };
    }

    getUserNames(province: string) {
        var psm = this.getPSM();
        var retVal: any[] = [];
        
        if (province === 'BC' || province === 'MB' || province === 'NS' || province === 'SK') {
            var apsNames = (this.livedataRoot as any).selectNodes('APSNames');
            if (psm === "S") {
                var vendors = apsNames[1];
                var userInfo = vendors.selectNodes('Name');
                for (let i = 0; i < userInfo.length - 1; i++) {
                    const name = userInfo[i].getAttribute('OnTitleName');
                    if (name) {
                        retVal.push(name);
                    }
                }
            } else if (psm === "M") {
                var mortagors = apsNames[2];
                var userInfo = mortagors.selectNodes('Name');
                for (let i = 0; i < userInfo.length - 1; i++) {
                    const name = userInfo[i].getAttribute('OnTitleName');
                    if (name) {
                        retVal.push(name);
                    }
                }
            } else {
                var purchasers = apsNames[0];
                var userInfo = purchasers.selectNodes('Name');
                for (let i = 0; i < userInfo.length - 1; i++) {
                    const name = userInfo[i].getAttribute('OnTitleName');
                    if (name) {
                        retVal.push(name);
                    }
                }
            }
        } else {
            if (psm === "S") {
                var sellers = (this.livedataRoot as any).selectNodes('Vendor');
                sellers.forEach(node => {
                    const name = node.getAttribute('Name');
                    if (name) {
                        retVal.push(name);
                    }
                });
            } else {
                var purchasers = (this.livedataRoot as any).selectNodes('Purchaser');
                purchasers.forEach(node => {
                    const name = node.getAttribute('Name');
                    if (name) {
                        retVal.push(name);
                    }
                });
            }
        }
        
        return retVal;
    }
    getConditionalUntilDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "P" || psm === "S") {
            ret = this.livedataRoot.getAttribute("CoditionalDate")
        }
        return ret;
    }
    
    getRequisionDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "P" || psm === "S") {
            ret = this.livedataRoot.getAttribute("RequisitionDate")
        }
        return ret;
    }
    getRequisitionSentDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "P") {
            ret = this.livedataRoot.getAttribute("RequisitionSentDate")
        }
        return ret;
    }
    getRequisitionReceivedDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "S") {
            ret = this.livedataRoot.getAttribute("RequisitionReceivedDate")
        }
        return ret;
    }
    getReverseTrustLetterDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "P" || psm === "S") {
            ret = this.livedataRoot.getAttribute("ReverseTrustLetterDate")
        }
        return ret;
    }
    getRequisitionResponseDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "P" || psm === "S") {
            ret = this.livedataRoot.getAttribute("RequisitionResponseDate")
        }
        return ret;
    }
    getEarlyPossessionDate(): string {
        return "";
    }
    getAdjustmentDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "P" || psm === "S") {
            ret = this.getFirstNode("Adjustment")?.attributes?.AdjustmentDate;
        }
        return ret;
    }
    getCoditionalDate(): string {
        var ret = "";
        if (this.livedataRoot.getAttribute("OfferConditional") === "1") {
            ret = this.livedataRoot.getAttribute("CoditionalDate")
        }
        return ret;
    }
    getClientName(): string {
        return this.livedataRoot.getAttribute("ClientName");
    }
    getClientNameSurnames(): string {
        return this.livedataRoot.getAttribute("ClientNameSurnames");
    }
    getLawyerInitials(): string {
        return this.livedataRoot.getAttribute("LawyerInitials")
    }
    getStaffInitials(): string {
        const staffNode = (this.livedataRoot as any).selectSingleNode('Staff');
        return staffNode?.getAttribute("Initials");
    }
    getNewHome(): string {
        return this.livedataRoot.getAttribute("NewHome"); // 0: new home, 1: not new home
    }
    setNewHome(newHome: string): void {
        let node = this.livedataRoot as any
        if(newHome === "0"){
            node.setAttribute("NewHome", "0")
        } else if (newHome === "1"){
            node.setAttribute("NewHome", "1")
            node.setAttribute('GSProjectCode','');
            node.setAttribute('GSDescription','Project not in New Home Program');
        } else {
            console.log("invalid value for New Home: ", newHome);
        }
    }
    getInterimClosingDate(): string {
        var ret = "";
        var psm = this.getPSM();
        if (psm === "P" || psm === "S") {
            var propType = this.getPropertyType();
            if (this.livedataRoot.getAttribute("NewHome") === "0" && (propType === "Condo" || propType === "CondoSubleasehold")) {
                ret = this.livedataRoot.getAttribute("InterimClosingDate");
            }
        }
        return ret;
    }
    getClientContactInfo(province: string, skip?: boolean) {
        var retVal: any[] = [];
        var psm = this.getPSM();
        
        if (psm === "S") {
            var sellers = (this.livedataRoot as any).selectNodes('Vendor')
            sellers.forEach(node => {
                var contactInfo = node.selectNodes("ContactInfo");
                contactInfo.forEach(contact => {
                    if (contact.getAttribute('ContactMethod') === "Email") {
                        var email = contact.getAttribute('ContactMethodInfo');
                        if (email) {
                            retVal.push(email);
                        }
                    }
                })
            })
        } else {
            var purchasers = (this.livedataRoot as any).selectNodes("Purchaser")
            purchasers.forEach(node => {
                var contactInfo = node.selectNodes("ContactInfo");
                contactInfo.forEach(contact => {
                    if (contact.getAttribute('ContactMethod') === "Email") {
                        var email = contact.getAttribute('ContactMethodInfo');
                        if (email) {
                            retVal.push(email);
                        }
                    }
                })
            })
        }

        if (retVal.length > 0) {
            return retVal;
        } else if (!skip) {
            alert("Please set an email for each user to get notified about any updates")
        }
    }

    getClientEmail() {
        var retVal: any[] = [];
        var psm = this.getPSM();
        
        if (psm === "S") {
            var sellers = (this.livedataRoot as any).selectNodes('Vendor')
            sellers.forEach(node => {
                var name = node.getAttribute('Name');
                var contactInfo = node.selectNodes("ContactInfo");
                contactInfo.forEach(contact => {
                    if (contact.getAttribute('ContactMethod') === "Email") {
                        var email = contact.getAttribute('ContactMethodInfo');
                        if (email) {
                            retVal.push({name, email});
                        }
                    }
                })
            })
        } else {
            var purchasers = (this.livedataRoot as any).selectNodes("Purchaser")
            // console.log(purchasers)
            purchasers.forEach(node => {
                var name = node.getAttribute('Name');
                var contactInfo = node.selectNodes("ContactInfo");
                contactInfo.forEach(contact => {
                    if (contact.getAttribute('ContactMethod') === "Email") {
                        var email = contact.getAttribute('ContactMethodInfo');
                        if (email) {
                            retVal.push({name, email});
                        }
                    }
                })
            })
        }

        if (retVal.length > 0) {
            return retVal;
        }
    }

    exportSolunoXSLT() {
        try {
            runInnerFunction("ExportToSoluno", null);
        } catch (e) {
            alert(`Error in exporting to Soluno: ${e.message || e}`);
        }
    }

    getSolunoData(province: string) {

        var dataRoot = this.livedataRoot as any;
        const fullName = dataRoot.getAttribute("ClientName")?.split(" and")[0] || dataRoot.getAttribute("ClientName");
        var property = dataRoot.selectSingleNode("Property");

        // Get contact info based on province
        let contactInfo;
        if (province === 'BC' || province === 'MB' || province === 'NS' || province === 'SK') {
            const skReader = new SKDataReader(this.livedataRoot);
            contactInfo = skReader.getClientContactInfo(province, true);
        } else {
            contactInfo = this.getClientContactInfo(province, true);
        }

        const email = contactInfo?.[0] || null;
        const mailingAddress = dataRoot.getAttribute("PropertyAddress");
        const city = property ? property.getAttribute("City") : null;
        const postalCode = property ? property.getAttribute("PostalCode") : null;

        // Get Soluno task data
        const solunoNode = dataRoot.selectSingleNode("Soluno");
        const taskData = [];
        
        if (solunoNode) {
            const items = solunoNode.selectNodes("Item");
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                taskData.push({
                    Description: item.getAttribute("Description"),
                    ItemType: item.getAttribute("ItemType"),
                    OtherTaxType: item.getAttribute("OtherTaxType"),
                    Amount: item.getAttribute("Amount"),
                    IsTaxable: item.getAttribute("IsTaxable"),
                    CodeType: item.getAttribute("CodeType"),
                    ExportToSoluno: item.getAttribute("ExportToSoluno")
                });
            }
        }

        return {
            contactInfo: {
                fullName,
                mailingAddress,
                city,
                postalCode,
                province,
                email,
            },
            taskData
        };
    }
    setSolunoItemExport(description: string): void {
        const solunoNode = (this.livedataRoot as any).selectSingleNode("Soluno");
        const items = solunoNode.selectNodes("Item");
        
        // Find the item with matching description and toggle its ExportToSoluno value
        items.forEach(item => {
            if (item.getAttribute("Description") === description) {
                item.setAttribute("ExportToSoluno", item.getAttribute("ExportToSoluno") === '1' ? '0' : '1');
            }
        });
    }

    getFirmName() {
        const livedataRoot = (this.livedataRoot as any);
        const lawyer = livedataRoot?.selectSingleNode('lawyer');
        const firmName = lawyer?.getAttribute('FirmName');
        return firmName;
    }

    updateIntakeInformation(name: string, updateVal: any) {
        try {
            runInnerFunction('UpdateIntakeInformation',
                {
                    name: name,
                    updatedVal: updateVal
                });
        } catch (e) {
            alert(`Error in updating intake field value: ${e.message || e}`)
        }
    }
    getDashboardFields(): any {

        try {
            const dashFields =  (this.livedataRoot as any).selectSingleNode("ClientConnectDashboardFields").attributes;
            const dashFieldVals = Array.from(dashFields).reduce((obj: any, node: any) => {
                obj[node.nodeName] = node.nodeValue;
                return obj
            }, {});

            return dashFieldVals;
        } catch (e) {
            return null;
        }
    }
    setDashboardIsDirty(): void {
        const dashFields =  (this.livedataRoot as any).selectSingleNode("ClientConnectDashboardFields");
        dashFields.setAttribute("isDirty", 0);
        runInnerFunction('SaveFile', true);
    }

    setLanguage(language: string): void {
        const langCodeMap = {
            "English": 'EN',
            "Chinese": 'zhCN',
            "French": 'FR'
        }

        const lawyerNode = (this.livedataRoot as any).selectSingleNode("lawyer")
        lawyerNode.setAttribute("language", langCodeMap[language]);
        runInnerFunction('SaveFile', true);
    }

    setDashboardFieldsNotDirty() {
        const dashFields =  (this.livedataRoot as any).selectSingleNode("ClientConnectDashboardFields")
        const nodes = dashFields.attributes;
        if (nodes) {
            for (let i = 0; i < nodes.length - 2; i++) {
                const nodeName = nodes[i].nodeName;
                if (nodeName.endsWith("isDirty")) {
                    dashFields.setAttribute(nodeName, 0);
                }
            }
            runInnerFunction('SaveFile', true);
        } else {
            console.log("No ClientConnectDashboardFields found");
        }
    }
    setDashboardFieldsDirty(name: string) {
        const dashFields =  (this.livedataRoot as any).selectSingleNode("ClientConnectDashboardFields");

        if (dashFields) {
            dashFields.setAttribute(name + "isDirty", 1);
            dashFields.setAttribute("isDirty", 1);
        } else {
            console.log("No ClientConnectDashboardFields found");
        }

    }
    getInitials(name: string): string {
        return name
        .split(' ')
        .map(word => word[0].toUpperCase())
        .join('');
    }
    setFirmContactInfo(info: any, skipUpdateView?: boolean): void {
        var dRoot = (this.livedataRoot as any);
        const prov = dRoot.getAttribute('ApplicationSubCode');
        if (info.Email && (info.FirmEmail !== undefined)) {
            dRoot.setAttribute('FirmEmail', info.Email);
        } else {
            dRoot.setAttribute('FirmEmail', info.FirmEmail);
        }
        // Handle both SubUserID (from API) and SubUserId (from transformed data)
        const subUserId = info.SubUserId || info.SubUserID;
        if (subUserId) {
            dRoot.setAttribute('FirmContactID', subUserId);
        }

        const locationNumber = info.LocationNumber || info.locationCode;
        
        // Remove existing Staff node
        const existingStaffNode = dRoot.selectSingleNode('Staff');
        if (existingStaffNode) {
            dRoot.removeChild(existingStaffNode);
        }

        // Create new Staff node
        const newStaffNode = dRoot.ownerDocument.createElement('Staff');
        dRoot.appendChild(newStaffNode);

        // If location number exists, get location info from lawyer node
        if (locationNumber && locationNumber !== '') {
            const lawyerNode = dRoot.selectSingleNode('lawyer');
            const firmLocations = lawyerNode?.selectNodes('FirmLocations');
            newStaffNode.setAttribute('LocationNumber', locationNumber);

            for (let i = 0; i < firmLocations.length; i++) {
                if (firmLocations[i].getAttribute('LocationCode') === locationNumber) {
                    info.ContactMethodInfo = firmLocations[i].getAttribute('LocLine1') || '';
                    info.FirmCitySign = firmLocations[i].getAttribute('LocLine2') || '';
                    info.FirmMunicipalitySign = firmLocations[i].getAttribute('LocLine3') || '';
                    info.FirmStreet1 = firmLocations[i].getAttribute('FirmStreet1') || '';
                    info.FirmStreet2 = firmLocations[i].getAttribute('FirmStreet2') || '';
                    info.FirmStreet3 = firmLocations[i].getAttribute('FirmStreet3') || '';
                    info.FirmCity = firmLocations[i].getAttribute('FirmCity') || '';
                    info.FirmProvince = firmLocations[i].getAttribute('FirmProvince') || '';
                    info.FirmPostalCode = firmLocations[i].getAttribute('FirmPostalCode') || '';
                    info.FirmWebsite = firmLocations[i].getAttribute('FirmWebsite') || '';
                    info.FirmPhoneLoc = firmLocations[i].getAttribute('FirmPhone') || '';
                    info.FirmFaxLoc = firmLocations[i].getAttribute('FirmFax') || '';
                    info.FirmEmailLoc = firmLocations[i].getAttribute('FirmEmail') || '';
                }
            }
        }

    // Set attributes for the new Staff node
    Object.keys(info).forEach(key => {
        if (info[key] !== undefined && info[key] !== '' && info[key] !== null) {
            // Normalize SubUserID to SubUserId for consistency
            const normalizedKey = key === 'SubUserID' ? 'SubUserId' : key;
            
            if (!info.Phone && !info.Fax && !info.Email) { //Only Users side
                if (key === 'FirmPhone') {
                    newStaffNode.setAttribute('Phone', info[key]);
                }
                else if (key === 'FirmFax') {
                    newStaffNode.setAttribute('Fax', info[key]);
                } 
                else if (key === 'FirmPhoneLoc') {
                    newStaffNode.setAttribute('FirmPhone', info[key]);
                }
                else if (key === 'FirmFaxLoc') {
                    newStaffNode.setAttribute('FirmFax', info[key]);
                }
                else if (key === 'FirmEmailLoc') {
                    newStaffNode.setAttribute('FirmEmail', info[key]);
                }
                else if (key !== 'FirmEmail') {
                    newStaffNode.setAttribute(normalizedKey, info[key]);
                }
            } else {
                newStaffNode.setAttribute(normalizedKey, info[key]);
            }
        }
    });

        // Handle MiscContact node
        const existingMiscNode = newStaffNode.selectSingleNode('MiscContact');
        if (existingMiscNode) {
            newStaffNode.removeChild(existingMiscNode);
        }

        // const miscNode = dRoot.ownerDocument.createElement('MiscContact');
        var miscAttributes = []
        if (prov === 'AB') {
            if (info.Email || info.Email === '') { // if staff member
                miscAttributes = ['CellPhone', 'WorkPhone', 'WorkFax', 'HomePhone', 'HomeFax'];
                newStaffNode.setAttribute('Email', info.Email);
            } else { // if user
                miscAttributes = ['CellPhone', 'WorkPhone', 'WorkFax', 'HomePhone', 'HomeFax'];
                newStaffNode.setAttribute('Email', info.FirmEmail);
            }
        } else {
            if (info.Email || info.Email === '') {
                miscAttributes = ['CellPhone', 'WorkPhone', 'WorkFax', 'Email', 'HomePhone', 'HomeFax'];
            } else {
                miscAttributes = ['CellPhone', 'WorkPhone', 'WorkFax', 'Email', 'HomePhone', 'HomeFax', 'FirmEmail'];
            }
        }

        miscAttributes.forEach(attr => {
            if (info[attr] !== undefined && info[attr] !== '' && info[attr] !== null) {
                // Convert camelCase to space-separated words
                let contactMethod;
                if (attr === 'FirmEmail' && !info.Email) {
                    // For FirmEmail, use "Email" as contact method if value exists
                    if (info['FirmEmail'] !== undefined && info['FirmEmail'] !== '' && info['FirmEmail'] !== null) {
                        contactMethod = 'Email';
                    }
                } else {
                    contactMethod = attr.replace(/([a-z])([A-Z])/g, '$1 $2');
                }
                
                // Create a new MiscContact node for each attribute
                const miscNode = dRoot.ownerDocument.createElement('MiscContact');
                miscNode.setAttribute('ContactMethod', contactMethod);
                miscNode.setAttribute('ContactMethodInfo', info[attr]);
                
                // Append the new contact node to the miscNode
                newStaffNode.appendChild(miscNode);
            }
        });

        this.setLawyerInfoFromFirmContact(newStaffNode, dRoot);
        if(!skipUpdateView){
            runInnerFunction('SetPageDirty', null); // activate save file button
            runInnerFunction('UpdateContentHolder', null);
        }
    }
    setLawyerInfoFromFirmContact(staffNode: any, dRoot: any): void {
        const attributes = [
            'FirmCitySign', 'FirmMunicipalitySign', 'FirmStreet1', 
            'FirmStreet2', 'FirmStreet3', 'FirmCity', 
            'FirmProvince', 'FirmPostalCode', 'FirmPhone', 
            'FirmFax', 'FirmEmail', 'FirmWebsite'
        ];
        if (staffNode != null) {
            if (staffNode.getAttribute('Name') != null) {dRoot.setAttribute('FirmContact', staffNode.getAttribute('Name'))}
            if (staffNode.getAttribute('LocationNumber') != null && staffNode.getAttribute('LocationNumber') != '') {
                var lawyerNode = dRoot.selectSingleNode('lawyer');
                if (lawyerNode != null) {
                    attributes.forEach(attr => {
                        if (staffNode.getAttribute(attr) != null) {
                            lawyerNode.setAttribute(attr, staffNode.getAttribute(attr));
                        }
                    });
                }
            }
        }
    }
    getAppCode(): string {
        return this.livedataRoot.getAttribute("ApplicationSubCode");
    }
    getFileNumber(): string {
        return this.livedataRoot?.getAttribute("MatterNumber");
    }
    setFileNumber(fileNumber: string): void {
        this.livedataRoot.setAttribute("MatterNumber", fileNumber);
        runInnerFunction("SetPageDirty", null);
        runInnerFunction("UpdateContentHolder", null);
    }
    getReline(): string {
        return this.livedataRoot.getAttribute("ReLine");
    }
    getLinkedAppID(): string {
        return this.livedataRoot.getAttribute("LinkedAppID");
    }
    getMortgageNodesLength(): number {
        return (this.livedataRoot as any).selectNodes("Mortgage").length;
    }
    getExtraPropertyNodesLength(): number {
        return (this.livedataRoot as any).selectNodes("Property/Property").length;
    }
    getPropertyAddress(): string {
        return this.livedataRoot.getAttribute("PropertyAddress");
    }
    getCoordinates(): {lat: number, lng: number} {
        const propertyNode = (this.livedataRoot as any)?.selectSingleNode("Property");
        return {
            lat: Number(propertyNode?.getAttribute("lat")) || 0,
            lng: Number(propertyNode?.getAttribute("lng")) || 0
        }
    }
    setCoordinates(lat: number, lng: number): void {
        const propertyNode = (this.livedataRoot as any)?.selectSingleNode("Property");
        propertyNode?.setAttribute("lat", lat.toString());
        propertyNode?.setAttribute("lng", lng.toString());
    }
    getPropertyPin(): string {
        return this.livedataRoot.getAttribute("PropertyPIN");
    }
    getUnitType(): string {
        const propertyNode = (this.livedataRoot as any).selectSingleNode("Property");
        return propertyNode?.getAttribute("UnitType");
    }
    getUnitNumber(): string {
        const propertyNode = (this.livedataRoot as any).selectSingleNode("Property");
        return propertyNode?.getAttribute("UnitNumber");
    }
    getStreetNumber(): string {
        const propertyNode = (this.livedataRoot as any).selectSingleNode("Property");
        return propertyNode?.getAttribute("StreetNumber");
    }
    getStreetName(): string {
        const propertyNode = (this.livedataRoot as any).selectSingleNode("Property");
        return propertyNode?.getAttribute("StreetName");
    }
    getStreetNumberSuffix(): string {
        const propertyNode = (this.livedataRoot as any).selectSingleNode("Property");
        return propertyNode?.getAttribute("StreetNumberSuffix");
    }
    getPostalCode(): string {
        const propertyNode = (this.livedataRoot as any).selectSingleNode("Property");
        return propertyNode?.getAttribute("PostalCode");
    }
    getCity(): string {
        const propertyNode = (this.livedataRoot as any).selectSingleNode("Property");
        return propertyNode?.getAttribute("City");
    }
    getMunicipality(): string {
        return (this.livedataRoot as any).selectSingleNode("LegalDescriptionInput")?.getAttribute("Municipality");
    }
    getAppId(): string {
        return this.livedataRoot?.getAttribute("AppID")
    }
    getClientConnectId(): string {
        return this.livedataRoot?.getAttribute("ClientConnectId")
    }
    getLawyerId(): string {
        return this.livedataRoot.getAttribute("LawyerID")
    }
    getLanguage(): string {
        return this.livedataRoot.getAttribute("Language")
    }
    getActingForLenderOnly(): string {
        return this.livedataRoot.getAttribute("ActingForLenderOnly")
    }
    getPurchaseMoneyMortgage(): string {
        return this.livedataRoot.getAttribute("PurchaseMoneyMortgage")
    }
    getFileType(): string {
        var ret = "";
        switch (this.getPSM()) {
            case "P":
                ret = "Purchase";
                if (
                    this.getAppCode() === "BC" && 
                    this.getPSMDummy() === "T"
                ) {
                    ret = "Title Transfer";
                }
                break;
            case "S":
                ret = "Sale";
                break;
            case "M":
                ret = "Mortgage";
                break;
            case "O":
                ret = "Polaris";
                break;
        }
        return ret;
    }
    getOtherAttribute(type: string): string {
        return this.livedataRoot.getAttribute(type);
    }
    setOtherAttribute(type: string, value: string): void {
        (this.livedataRoot as any).setAttribute(type, value);
        // go into property node and change assess 1 
        runInnerFunction("SetPageDirty", null);
    }
    getXMLList(type: string): any {
        let nodes = null;
        switch (type) {
            case "TransfereeDetails":
                nodes = (this.livedataRoot as any).selectNodes("Purchaser");
                break;
            case "TransferorDetails":
                nodes = (this.livedataRoot as any).selectNodes("Vendor");
                break;
            case "Mortgages":
                nodes = (this.livedataRoot as any).selectNodes("Mortgage");
                break;
            case "Defect":
                nodes = (this.livedataRoot as any).selectNodes("Defect");
                break;
            case "VIPInfo":
                nodes = (this.livedataRoot as any).selectNodes("VIPInfo");
                break;
            case "Deposit":
                nodes = (this.livedataRoot as any).selectNodes("Deposit");
                break;
            case "LegalDescriptionInput":
                nodes = (this.livedataRoot as any).selectNodes("LegalDescriptionInput");
                break;
            case "Property":
                nodes = (this.livedataRoot as any).selectNodes("Property");
                break;
            case "munic":
                nodes = (this.livedataRoot as any).selectNodes("munic");
                break;
            case "CondoContact":
                nodes = (this.livedataRoot as any).selectNodes("CondoContact");
                break;
            case "SimiliarNames":
                nodes = (this.livedataRoot as any).selectNodes("Defect[contains(@type,'21')]");
                break;
            case "Vendor":
                nodes = (this.livedataRoot as any).selectNodes("Vendor");
                break;
            case "APSNames":
                nodes = (this.livedataRoot as any).selectNodes("APSNames");
                break;
            case "Purchaser":
                nodes = (this.livedataRoot as any).selectNodes("Purchaser");
                break;
            case "PurchaserBankingInfo":
                nodes = (this.livedataRoot as any).selectNodes("PurchaserBankingInfo");
                break;
        }
        return nodes;
    }
    exclusiveAppendNodes(type: string, nodes: any[]) {
        this.deleteNodes(type);
        this.appendNodes(nodes);
    }
    appendNodes(nodes: any[]) {
        for (var idx = 0; idx < nodes.length; idx++) {
            this.livedataRoot.appendChild(nodes[idx].cloneNode(true));
        }
        runInnerFunction("SetPageDirty", null);
        runInnerFunction("UpdateContentHolder", null);
    }
    deleteNodes(type: string) {
        const nodes = this.getXMLList(type);
        for (var idx = 0; idx < nodes?.length; idx++) {
            nodes[idx].parentNode.removeChild(nodes[idx]);
        }
        runInnerFunction("SetPageDirty", null);
        // runInnerFunction("UpdateContentHolder", null);
    }
    deleteNode(type: string, index: number) {
        const nodes = this.getXMLList(type);
        if (nodes && nodes.length > 0 && nodes[index]) {
            nodes[index].parentNode.removeChild(nodes[index]);
        }

        runInnerFunction("SetPageDirty", null);
        runInnerFunction("UpdateContentHolder", null)
    }
    deleteReplySubNodes(index: number, parentIndex: number) {
        let node = this.livedataRoot as any;
        const mainNotes = node.selectNodes("MainNote")
        node = mainNotes[mainNotes.length - parentIndex - 1];
        const replyNode = node.selectSingleNode(`MainNoteReply[${index + 1}]`)
        node.removeChild(replyNode);
    }
    moveNodeDown(type: string, index: number) {
        const nodes = this.getXMLList(type);
        if (nodes && nodes.length > 0 && nodes[index] && index < nodes.length) {
            if (index + 1 < nodes.length) {
                const parent = nodes[index].parentNode;
                parent.insertAfter(nodes[index], nodes[index + 1]);
                switch (type) {
                    case "Mortgages":
                        runInnerFunction('ReactShell.setMortgageTabNum', index + 2);
                        break;
                    default:
                        runInnerFunction("UpdateContentHolder", null);
                        break;
                }
            }
        }
    }
    moveNodeUp(type: string, index: number) {
        const nodes = this.getXMLList(type);
        if (index > 0 && nodes && nodes.length > 0 && nodes[index]) {
            const parent = nodes[index].parentNode;
            parent.insertBefore(nodes[index], nodes[index - 1]);
            switch (type) {
                case "Mortgages":
                    runInnerFunction('ReactShell.setMortgageTabNum', index);
                    break;
                default:
                    runInnerFunction("UpdateContentHolder", null);
                    break;
            }
        }
    }
    getMortgagorInformation(): Array<PurchaserType> {
        let appcode = this.livedataRoot.getAttribute("ApplicationSubCode");
        const purchaser = this.getNodeInfo("Purchaser")
            .filter(purchaser => purchaser.attributes.Name)
            .map(node => {
                const att = node.attributes;
                return {
                    Name: (att.Name > "") ? att.Name : "blank",
                    IsPurchaser: att.IsPurchaser,
                    OnTitle: att.OnTitle,
                    personType: node.name,
                    AddressForService: (att.AddressForService > "") ? att.AddressForService : "",
                    TransfereeNameFull: (appcode === "ON" || appcode === "AB" ?
                        (att.TransfereeNameFull > "") ? att.TransfereeNameFull : att.Name :
                        appcode === "NS" ?
                            (att.OnTitleNameFull > "") ? att.OnTitleNameFull : att.OnTitleName :
                            null
                    ),
                    Birthday: att.BirthDate,
                    Gender: att.Gender,
                    TransfereeName: (appcode === "ON" || appcode === "AB" ?
                    (att.TransfereeName > "") ? att.TransfereeName : att.Name :
                    appcode === "NS" ?
                        (att.OnTitleName > "") ? att.OnTitleName : att.OnTitleName :
                        null
                    ),
                    SpouseNotOnTitle: att.SpouseNotOnTitle,
                    SpouseEmailAddress: att.SpouseEmailAddress,
                }
            });
        return purchaser;
    }
    getMortgagorName(): string {
        const mortgagors = this.getMortgagorInformation();
        const name = mortgagors.map((mortgagor) => mortgagor.TransfereeNameFull).join("; ");
        return name;
    }
    getPSM(): 'P' | 'S' | 'M' | 'O' | '' {
        const psm = this.livedataRoot.getAttribute("PSM");
        switch (psm) {
            case 'P':
            case 'S':
            case 'M':
            case 'O':
                return psm
            default:
                return ''
        }
    }
    getPSMDummy(): string {
        return this.livedataRoot.getAttribute("PSMDummy");
    }
    getClosingDate(): string {
        return this.livedataRoot.getAttribute('ClosingDate');
    }
    getDocumentMergeDate(): string[] {
        const root: any = this.livedataRoot as any;
        const lawyerNode: any = root?.selectSingleNode?.("lawyer");

        const DocumentMergeDate = this.livedataRoot.getAttribute("DocumentMergeDate") || "";
        // In DocControlSidePanel.xml these are bound to `xmlbase="lawyer"` and `xpath="@FirmCitySign"` / `@FirmMunicipalitySign`
        const FirmCitySign = lawyerNode?.getAttribute?.("FirmCitySign") || "";
        const FirmMunicipalitySign = lawyerNode?.getAttribute?.("FirmMunicipalitySign") || "";

        const DocumentMergeDateDay = this.livedataRoot.getAttribute("DocumentMergeDateDay") || "";
        const DocumentMergeDateMonth = this.livedataRoot.getAttribute("DocumentMergeDateMonth") || "";
        const DocumentMergeDateYear = this.livedataRoot.getAttribute("DocumentMergeDateYear") || "";

        return [
            DocumentMergeDate,
            FirmCitySign,
            FirmMunicipalitySign,
            DocumentMergeDateDay,
            DocumentMergeDateMonth,
            DocumentMergeDateYear,
        ];
    }
    getDocumentSignCheckBox(): string[] {
        const ElectronicSignature = this.livedataRoot.getAttribute("ElectronicSignature") || "";
        const DeliveryNotation = this.livedataRoot.getAttribute("DeliveryNotation") || ""; // SK, BC, and MB, This is input.long text
        const isRemoteSigning = this.livedataRoot.getAttribute("isRemoteSigning") || "";
        return [ElectronicSignature, DeliveryNotation, isRemoteSigning];
    }
    getLawyerName(): string {
        let purchaserLawyer = this.getNodeInfo("lawyer");
        if (purchaserLawyer.length === 0) return null;
        let n = purchaserLawyer[0].attributes["Name"]
        return n;
    }

    getOtherSideLawyerName(): string {
        let data = this.livedataRoot as any;
        let l = data.selectSingleNode("Solicitor")
        let n = l ? l.getAttribute("Name") : "";
        return n;
    }
    getBorrowerSideLawyerName(): string {
        let data = this.livedataRoot as any;
        let l = data.selectSingleNode("BorrowerSolicitor");
        let n = l ? l.getAttribute("Name") : "";
        return n;
    }

    getOtherSideLawyerFirmName(): string {
        let data = this.livedataRoot as any;
        let l = data.selectSingleNode("Solicitor")
        let n = l ? l.getAttribute("FirmName") : "";
        return n;
    }

    getOtherSideLawyerField(field: string): string {
        let data = this.livedataRoot as any;
        let l = data.selectSingleNode("Solicitor")
        let n = l ? l.getAttribute(field) : "";
        return n;
    }

    otherSideLawyerIsNotary(): boolean {
        let data = this.livedataRoot as any;
        let l = data.selectSingleNode("Solicitor");
        let n = l ? l.getAttribute("isNotary") : "";
        return (n === "1") ? true : false;
    }
    getOtherSideLawyerBadge(): string {
        return (this.otherSideLawyerIsNotary()) ? "Notary" : "Lawyer";
    }
    getVendorLawyerName(): string {
        let data = this.livedataRoot as any;
        let l = data.selectSingleNode("VendorSolicitor")
        let n = l ? l.getAttribute("Name") : "";
        return n;
    }
    getVendorLawyerField(field: string): string {
        let data = this.livedataRoot as any;
        let l = data.selectSingleNode("VendorSolicitor")
        let n = l ? l.getAttribute(field) : "";
        return n;
    }
    getFirmContact(): string {
        let purchaserLawyer = this.getNodeInfo("Staff");
        return (purchaserLawyer.length > 0) ? purchaserLawyer[0].attributes["Name"] : "";
    }
    getFirmContactID(): string[] {
        const node = this.livedataRoot as any;
        const staffNode = node.selectSingleNode("Staff");
        let firmContactType = 'user';
        let firmContactID = "";
        if (staffNode) {
            // Check for both SubUserId (normalized) and SubUserID (from API) for backward compatibility
            const subUserId = staffNode.getAttribute("SubUserId") || staffNode.getAttribute("SubUserID");
            if (subUserId && subUserId > "") {
                firmContactID = subUserId;
            } else if (staffNode.getAttribute("qpickrepository_id") > "") {
                firmContactID = staffNode.getAttribute("qpickrepository_id");
                firmContactType = 'staff';
            }
        }
        return [firmContactType, firmContactID];
    }
    getBuyerPeopleInfo(): Array<PurchaserType> {
        return this.getMortgagorInformation();
    }

    getRegistrationDetails(): Array<RegistrationType> {
        let transfer = this.getNodeInfo('Transfer');
        let registrationDetails: Array<RegistrationType> = [];
        if (transfer.length > 0) {
            let transferNode = transfer[0];
            registrationDetails.concat(
                {
                    Name: 'Transfer',
                    label: transferNode.attributes?.RegistrationDate
                }
            )
        }
        let mortgages = this.getMortgageInformation().map(node => {
            return {
                Name: node.Lender,
                label: 'Charge',
            }
        });
        let defects: Array<RegistrationType> = this.getNodeInfo('Defect')
            .filter(node => node.attributes['type'] === '32_2')
            .map(node => {
                let att = node.attributes;
                return {
                    Name: att.Name,
                    label: 'Discharge',
                }
            });
        registrationDetails.concat(mortgages, defects);
        return registrationDetails;
    }

    getSellerPeopleInfo(): Array<VendorType> {
        let vendor: Array<VendorType> = this.getVendorInformation();
        return vendor;
    }

    getPersonInfo(xNodeName: string): Array<PersonType> {
        return this.getNodeInfo(xNodeName).map(node => {
            let att = node.attributes;
            var name = att.Name;
            if (!(name > "")) {
                name = att.Company
            }
            const ret = {
                Name: name,
                personType: node.name,
            };
            switch (node.name) {
                case "OtherParty":
                    ret['OtherPartyType'] = att.OtherPartyType;
                    break;
            }
            ret["address"] = att.Address; 
            return ret;
        }
        ).filter((person) => person['Name'] !== undefined);
    }
    getThirdPartyInfo(): Array<PersonType> {
        let thirdParty: Array<PersonType> = [];
        let conveyancer: Array<PersonType> = this.getPersonInfo("Conveyancer").filter((person) => person['Name'] !== undefined);
        let mortgageBroker: PersonType = this.getPersonInfo("MortgageBroker").find((person) => person['Name'] !== undefined);
        let insuranceProvider: PersonType = this.getPersonInfo("InsuranceAgent").find((person) => person['Name'] !== undefined);
        let realEstateAgent: PersonType = this.getPersonInfo("RealEstateAgent").find((person) => person['Name'] !== undefined);
        let purchaserRealEstateAgent: PersonType = this.getPersonInfo("PurchaserRealEstateAgent").find((person) => person['Name'] !== undefined);
        let otherParties: Array<PersonType> = this.getPersonInfo("OtherParty").filter(person => (person["Name"] !== undefined && person["OtherPartyType"] !== undefined));
        thirdParty = thirdParty.concat(conveyancer, insuranceProvider, mortgageBroker, realEstateAgent, purchaserRealEstateAgent, otherParties);
        return thirdParty.filter((x) => x !== undefined);
    }
    getRealEstateAgent(): any {
        return (this.livedataRoot as any).selectSingleNode("RealEstateAgent");
    }
    getPurchaserRealEstateAgent(): any {
        return (this.livedataRoot as any).selectSingleNode("PurchaserRealEstateAgent");
    }
    getTitleSearch(): Array<TitleSearchType> {
        let titleSearches = this.getNodeInfo("Defect"
        ).map(
            (node) => node.children.find((child) => child.name === "TitleSearch")
        ).filter(
            // Find all defects which have Title Search children
            (node) => node !== undefined
        ).map(
            // Extract Data
            (node) => {
                const dateAttr = node.attributes["RegDate"];
                let date: Date;
                if (dateAttr && dateAttr.length > 0) {
                    date = new Date(dateAttr)
                }
                return { date: date }
            }
        )
        return titleSearches
    }

    getInsuranceInformation(): TitleInsuranceType {
        return { insuranceProvider: this.livedataRoot.ownerDocument.getElementsByTagName("TPAppXML")[1]?.getAttribute("InsuranceProvider") };
    }

    getMortgageInformation(): Array<MortgageType> {
        const dataRoot = this.livedataRoot as any;
        const PSM: string = dataRoot ? dataRoot.getAttribute("PSM") : '';
        const mortgages = this.getNodeInfo("Mortgage").map(node => {
            return {
                Lender: (node?.attributes['Lender'] > "") ? node?.attributes['Lender'] : "blank",
                PSM: PSM,
                registrationDate: node.attributes['MtgRegistrationDate'],
                instrumentNumber: node.attributes['MtgInstrumentNumber'],
                position: node.attributes['MortgagePositionCode'],
                type: (node.attributes['IsVTB'] === "1") ? 'VTB' : 'New',
            } as MortgageType
        });

        for (let i = mortgages.length - 1; i >= 0; i--) {
            // start from the end & only check the end mortgage
            if (mortgages[i].Lender === "blank" && mortgages[i].type !== "VTB") {
                mortgages.splice(i, 1);
            }
        }
        return mortgages
    }

    getDefectMortgages(): Array<MortgageType> {
        const dataRoot = this.livedataRoot as any;
        const PSM: string = dataRoot ? dataRoot.getAttribute("PSM") : '';
        const DEFECT_ID = ["32_2", "32_1"];
        const mortgages = this.getNodeInfo("Defect")
            .filter((node) => DEFECT_ID.indexOf(node.attributes['type']) !== -1)
            .map((node, index) => {
                const dataNode = node.children.find(nodeElmt => nodeElmt.name === "Data");
                const lenderNode = dataNode?.children?.find(nodeElmt => nodeElmt.name === "Lender");
                switch (node.attributes["type"]) {
                    case "32_2":
                        if ((this.getAppCode() === "BC" || this.getAppCode() === "SK") && dataNode?.attributes["AssumedMortgage"] === "1") { // BC assumed
                            return {
                                Lender: ((lenderNode?.attributes['Lender'] > "") ? lenderNode?.attributes['Lender'] : ((dataNode?.attributes['Lender'] > "") ? dataNode?.attributes['Lender'] : "")),
                                PSM: PSM,
                                registrationDate: node.attributes['PayoutToDate'],
                                instrumentNumber: node.attributes['RefNumber'],
                                position: String(index),
                                type: 'Assumed'
                            } as MortgageType;
                        } else { // AB, ON
                            const mortgageType = (dataNode?.attributes['ReqResult'] === "IssueToRemain" && this.getAppCode() === "BC" ) ? 'Remaining' : 'Discharge';
                            return {
                                Lender: ((lenderNode?.attributes['Lender'] > "") ? lenderNode?.attributes['Lender'] : ((dataNode?.attributes['Lender'] > "") ? dataNode?.attributes['Lender'] : "")),
                                PSM: PSM,
                                registrationDate: node.attributes['PayoutToDate'],
                                instrumentNumber: node.attributes['RefNumber'],
                                position: String(index),
                                type: mortgageType
                            } as MortgageType;
                        }
                    case "32_1": // ON
                    default:
                        return {
                            Lender: ((lenderNode?.attributes['Lender'] > "") ? lenderNode?.attributes['Lender'] : ((dataNode?.attributes['Lender'] > "") ? dataNode?.attributes['Lender'] : "")),
                            PSM: PSM,
                            registrationDate: "",
                            instrumentNumber: "",
                            position: String(index),
                            type: 'Assumed'
                        } as MortgageType;
                }

            })
        return mortgages
    }
    getFinancialInformation(): FinanceType {
        let account = this.getFirstNode("Account")
        let adjustment = this.getFirstNode("Adjustment")
        let trust = this.getFirstNode("Trust")
        let interimAdjustment = this.getFirstNode("InterimAdjustment")
        const parseMoney = (value?: string): number => {
            const parsed = parseFloat(value ?? "");
            return Number.isFinite(parsed) ? Math.round(parsed * 100) / 100 : 0;
        };
        const getTrustReceivedAmountByDescription = (description: string): number => {
            const root = this.livedataRoot as any;
            if (!root?.selectNodes) return 0;
            const nodes = root.selectNodes("Trust/Received") || [];
            const normalizedTarget = (description || "").trim().toLowerCase();
            let fallbackAmount = 0;
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                const nodeDescription = (node?.getAttribute?.("Description") || "").trim().toLowerCase();
                const itemName = (node?.getAttribute?.("itemName") || "").trim();
                const amount = parseMoney(node?.getAttribute?.("Amount"));
                if (nodeDescription === normalizedTarget) {
                    return amount;
                }
                if (!fallbackAmount && (itemName === "BDOC1" || itemName === "BDOC")) {
                    fallbackAmount = amount;
                }
            }
            return fallbackAmount;
        };
        const getTrustOwingToAmount = (): number => {
            const root = this.livedataRoot as any;
            const trustNode = root?.selectSingleNode?.("Trust");
            return parseMoney(trustNode?.getAttribute?.("TrustOwingTo"));
        };
        const getEstimatedFundsOwing = (): { owingFrom: number; owingTo: number } => {
            const root = this.livedataRoot as any;
            const estimatedNode = root?.selectSingleNode?.("EstimatedFunds");
            return {
                owingFrom: parseMoney(estimatedNode?.getAttribute?.("EstimatedClosingOwingFrom")),
                owingTo: parseMoney(estimatedNode?.getAttribute?.("EstimatedClosingOwingTo")),
            };
        };
        const trustOwingFrom = parseMoney(trust?.attributes.TrustOwingFrom);
        const trustOwingTo = parseMoney(trust?.attributes.TrustOwingTo);
        const estimatedFunds = getEstimatedFundsOwing();
        let returnValue: FinanceType = {
            account: {
                total: parseMoney(account?.attributes.Total),
            },
            adjustment: {
                bdoc: parseMoney(adjustment?.attributes.BDOC),
            },
            trust: {
                owingFrom: trustOwingFrom,
                owingTo: trustOwingTo,
                estimatedOwingFrom: estimatedFunds?.owingFrom ?? trustOwingFrom ?? 0,
                estimatedOwingTo: estimatedFunds?.owingTo ?? trustOwingTo ?? 0,
            },
            interimAdjustment: {
                interimBDOC: interimAdjustment?.attributes.InterimBDOC ? parseMoney(interimAdjustment?.attributes.InterimBDOC) : null,
            }
        };

        const netSaleProceeds = getTrustReceivedAmountByDescription("Net Sale Proceeds");
        if (netSaleProceeds > 0) {
            returnValue.trust.netSaleProceeds = netSaleProceeds;
        }
        const balanceSaleProceeds = getTrustOwingToAmount();
        if (balanceSaleProceeds > 0) {
            returnValue.trust.balanceSaleProceeds = balanceSaleProceeds;
        }
        return returnValue;
    }

    getVendorInformation(): Array<VendorType> {
        let appcode = this.livedataRoot.getAttribute("ApplicationSubCode");
        let vendors = this.getNodeInfo("Vendor").map(node => {
            let att = node.attributes;
            return {
                IsVendor: att.IsVendor,
                OnTitle: att.OnTitle,
                Name: (att.Name > "") ? att.Name : "blank",
                personType: "Vendor",
                TransferorNameFull: (appcode === "ON" || appcode === "AB" ?
                    (att.TransferorNameFull > "") ? att.TransferorNameFull : att.Name :
                    appcode === "NS" ?
                        (att.OnTitleNameFull > "") ? att.OnTitleNameFull : att.OnTitleName :
                        null
                ),
                TransferorName: att.TransferorName,
                Gender: att.Gender,
                AddressForService: att.AddressForService,
                HSTNumber: att.GSTNumber,
                SpouseNotOnTitle: att.SpouseNotOnTitle,
                SpouseEmailAddress: att.SpouseEmailAddress,
            }
        }
        );
        let results = vendors.filter((vendor) => vendor.Name !== "blank");
        return results;
    }
    getDefectInformation(): Array<Record<string, string>> {
        let defectInfo = this.getNodeInfo("Defect")
        for (let matter of defectInfo) {
            if (matter.children.find(node => node.name === "Data")?.attributes['CheckResolved'] === "1") {
                matter.attributes['CheckResolved'] = '1';
            } else {
                matter.attributes['CheckResolved'] = '0';
            }
            if (matter.children.find(node => node.name === "Data")?.attributes['ReqResult']) {
                matter.attributes['ReqResult'] = matter.children.find(node => node.name === "Data")?.attributes['ReqResult'];
            }
        }

        return defectInfo.map(node => node.attributes)
    }

    getMainNoteInformation(): Array<XMLJSON> {
        let returnNodes: Array<XMLJSON>;
        returnNodes = this.getNodeInfo('MainNote');
        return returnNodes;
    }

    getNodeInformation(nodeName: string): Array<XMLJSON> {
        let returnNodes: Array<XMLJSON>;
        returnNodes = this.getNodeInfo(nodeName);
        return returnNodes;
    }

    getContractInformation(): { closingDate: Date, propertyAddress: string } {
        const closingDateAttr = this.livedataRoot.getAttribute("ClosingDate");
        let closingDate;
        if (closingDateAttr && closingDateAttr.length > 0) {
            closingDate = new Date(closingDateAttr);
        }
        return {
            'closingDate': closingDate,
            'propertyAddress': this.livedataRoot.getAttribute("PropertyAddress"),
        }
    }

    private getFirstNode(nodeName: string): XMLJSON {
        let nodeList = this.getNodeInfo(nodeName);
        if (nodeList.length > 0) {
            return nodeList[0]
        }
    }
    protected getNodeInfo(nodeName: string): Array<XMLJSON> {
        const NodeList = (this.livedataRoot as any).selectNodes(nodeName);
        //Skip last empty add new node
        let nodes: Array<XMLJSON> = [];
        for (let i = 0; i < NodeList.length; i++) {
            nodes = nodes.concat(convertXMLtoJSON(NodeList[i]));
        }
        return nodes;
    }
    getTPAppXMLNode(): Array<XMLJSON> {
        let nodes: Array<XMLJSON> = [];
        nodes = nodes.concat(convertXMLtoJSON(this.livedataRoot))
        return nodes;
    }

    setVTB() {
        runInnerFunction('ReactShell.reactAddVTB', null);
    }
    setIndividual(nodeType: string, pos: number): boolean {
        const node = this.livedataRoot as any;
        if (nodeType !== PopupPageId.Transferee && nodeType !== PopupPageId.Transferor) {
            return false;
        }
        const nodeString = nodeType === PopupPageId.Transferee ? "Purchaser" : "Vendor";
        const person = node.selectSingleNode(`${nodeString}[${pos}]`);
        if (person) {
            person.setAttribute("Gender", "");
            runInnerFunction(nodeType === PopupPageId.Transferee ? "ReactShell.reactSelectMortgagor" : "ReactShell.reactSelectVendor", pos);
            return true;
        } else {
            return false;
        }
    }
    setCorporation(nodeType: string, pos: number): boolean {
        const node = this.livedataRoot as any;
        if (nodeType !== PopupPageId.Transferee && nodeType !== PopupPageId.Transferor) {
            return false;
        }
        const nodeString = nodeType === PopupPageId.Transferee ? "Purchaser" : "Vendor";
        const person = node.selectSingleNode(`${nodeString}[${pos}]`);
        if (person) {
            person.setAttribute("Gender", "Corporation");
            runInnerFunction(nodeType === PopupPageId.Transferee ? "ReactShell.reactSelectMortgagor" : "ReactShell.reactSelectVendor", pos);
            return true;
        } else {
            return false;
        }
    }
    setEstate(nodeType: string, pos: number): boolean {
        const node = this.livedataRoot as any;
        if (nodeType !== PopupPageId.Transferee && nodeType !== PopupPageId.Transferor) {
            return false;
        }
        const nodeString = nodeType === PopupPageId.Transferee ? "Purchaser" : "Vendor";
        const person = node.selectSingleNode(`${nodeString}[${pos}]`);
        if (person) {
            person.setAttribute("IsEstate", "1");
            person.setAttribute("Gender", "");
            runInnerFunction(nodeType === PopupPageId.Transferee ? "ReactShell.reactSelectMortgagor" : "ReactShell.reactSelectVendor", pos);
            return true;
        } else {
            return false;
        }
    }
    setOtherPartyType(pos: number, value: string): void {
        runInnerFunction('ReactShell.setOtherPartyType', { index: pos, value: value });
    }
    getUserID(): string {
        return this.livedataRoot.getAttribute("UserID");
    }
    getTeraviewAccountIsPresent(): string {
        const node = this.livedataRoot as any;
        if (node === undefined || node === null)
            return '';
        let thirdPartyAccounts = node.selectSingleNode('lawyer/ThirdPartyAcounts');
        if (thirdPartyAccounts === null || thirdPartyAccounts === undefined)
            return '';
        if (thirdPartyAccounts.length <= 0) // no third party account node
            return '';
        let accountNodes = thirdPartyAccounts.selectNodes('Account');
        if (accountNodes.length <= 0)
            return '';
        for (let i = 0; i < accountNodes.length; i++) {
            if (accountNodes[i].getAttribute('Party') === "Teraview") {
                if (accountNodes[i].getAttribute('AccountName') > "" && accountNodes[i].getAttribute('AccountName') !== null) {
                    return accountNodes[i].getAttribute('AccountName');
                }
            }
        }
        return '';
    }
    getSolunoDetailsIfPresent(): { org: string, email: string, password: string } {
        const node = this.livedataRoot as any;
        if (node === undefined || node === null)
            return { org: '', email: '', password: '' };
        
        let thirdPartyAccounts = node.selectSingleNode('lawyer/ThirdPartyAcounts');
        if (thirdPartyAccounts === null || thirdPartyAccounts === undefined)
            return { org: '', email: '', password: '' };
        
        if (thirdPartyAccounts.length <= 0) // no third party account node
            return { org: '', email: '', password: '' };
        
        let accountNodes = thirdPartyAccounts.selectNodes('Account');
        if (accountNodes.length <= 0)
            return { org: '', email: '', password: '' };
    
        for (let i = 0; i < accountNodes.length; i++) {
            if (accountNodes[i].getAttribute('Party') === "Soluno") {
                const org = accountNodes[i].getAttribute('OrganizationName');
                const email = accountNodes[i].getAttribute('Email');
                const password = accountNodes[i].getAttribute('Password');
                

                if (email > "" && email !== null && password > "" && password !== null) {
                    return {
                        org: org,
                        email: email,
                        password: password,
                    };
                }
            }
        }
        
        return { org: '', email: '', password: '' };
    }
    getThirdPartyAccountAttribute(accountIdentificationString: string, targetAttribute: string): string {
        const node = this.livedataRoot as any;
        if (node === undefined || node === null)
            return '';
        let thirdPartyAccounts = node.selectSingleNode('lawyer/ThirdPartyAcounts');
        if (thirdPartyAccounts === null || thirdPartyAccounts === undefined)
            return '';
        if (thirdPartyAccounts.length <= 0) // no third party account node
            return '';
        let accountNodes = thirdPartyAccounts.selectNodes('Account');
        if (accountNodes.length <= 0)
            return '';
        for (let i = 0; i < accountNodes.length; i++) {
            if (accountNodes[i].getAttribute('Party') === accountIdentificationString) {
                if (accountNodes[i].getAttribute(targetAttribute) > "" && accountNodes[i].getAttribute(targetAttribute) !== null) {
                    return accountNodes[i].getAttribute(targetAttribute);
                }
            }
        }
        return '';
    }
    getPIPFormID(): string {
        const node = this.livedataRoot as any;
        if (node === undefined || node === null)
            return '';
        return node.getAttribute('PIPFormID');
    }
    setPIPFormID(pipformid: string): void {
        let node = this.livedataRoot as any;
        node.setAttribute('PIPFormID', pipformid);
        runInnerFunction("SetPageDirty", null);
    }
    setPIPConfirmnationNumber(confirmId: string): void {
        let node = this.livedataRoot as any;
        let legalDescriptinInputNode = node.selectSingleNode('LegalDescriptionInput');
        if (legalDescriptinInputNode === null || legalDescriptinInputNode === undefined)
            return;
        if (legalDescriptinInputNode.length <= 0)
            return;
        legalDescriptinInputNode.setAttribute('PipConfirmationNumber', confirmId);
        runInnerFunction("SetPageDirty", null);
    }
    getPIPConfirmnationNumber(): string {
        let node = this.livedataRoot as any;
        let legalDescriptinInputNode = node.selectSingleNode('LegalDescriptionInput');
        if (legalDescriptinInputNode === null || legalDescriptinInputNode === undefined)
            return;
        if (legalDescriptinInputNode.length <= 0)
            return;
        return legalDescriptinInputNode.getAttribute('PipConfirmationNumber');
    }
    getTransferInstrumentNumber(): string {
        let node = this.livedataRoot as any;
        let transferNode = node.selectSingleNode('Transfer');
        let transferNum = transferNode.getAttribute('InstrumentNumber');
        if (transferNum === undefined || transferNum === null)
            return '';
        return transferNum;
    }
    setTransferInstrumentNumber(instrumentNumber: string): void {
        let node = this.livedataRoot as any;
        let transferNode = node.selectSingleNode('Transfer');
        if (instrumentNumber <= '')
            return;
        if (transferNode === undefined || transferNode === null)
            return;
        transferNode.setAttribute('InstrumentNumber', instrumentNumber);
        runInnerFunction("SetPageDirty", null);
    }
    setTransferRegistrationDate(date: string): void {
        let node = this.livedataRoot as any;
        let transferNode = node.selectSingleNode('Transfer');
        if (date <= '')
            return;
        if (transferNode === undefined || transferNode === null)
            return;
        transferNode.setAttribute('RegistrationDate', date);
        runInnerFunction("SetPageDirty", null);
    }
    getRegistrationDate(): string {
        let node = this.livedataRoot as any;
        let transferNode = node.selectSingleNode('Transfer');
        if (transferNode === undefined || transferNode === null)
            return;
        let retVal = transferNode.getAttribute('RegistrationDate');
        if (retVal === undefined || retVal === null) {
            return '';
        }
        return retVal;
    }
    getRegistryOffice(): string {
        let node = this.livedataRoot as any;
        let registryOffice = node.getAttribute('RegistryOfficeID');
        if (registryOffice === null || registryOffice === undefined)
            return '';
        return registryOffice;
    }
    getCreateTransfer(): string {
        let node = this.livedataRoot as any;
        let createTransfer = node.getAttribute('CreateTransfer');
        if (createTransfer === null || createTransfer === undefined)
            return '';
        return createTransfer;
    }
    setCreateTransfer(createTransfer: string): void {
        let node = this.livedataRoot as any;
        node.setAttribute('CreateTransfer', createTransfer);
    }
    setDockerId(dockerId: string): void {
        let node = this.livedataRoot as any;
        if (dockerId === null || dockerId === undefined)
            return;
        node.setAttribute('DocketID', dockerId);
        node.setAttribute('isDocketIDOverWrite', '1');
    }
    getDockerId(): string {
        let node = this.livedataRoot as any;
        let dockerId = node.getAttribute('DocketID');
        if (dockerId === null || dockerId === undefined || dockerId === '')
            return '';
        return dockerId;
    }
    setDockerName(dockerName: string): void {
        let node = this.livedataRoot as any;
        if (dockerName === null || dockerName === undefined)
            return;
        node.setAttribute('DocketName', dockerName);
        node.setAttribute('isDocketNameOverWrite', '1');
    }
    getDockerName(): string {
        let node = this.livedataRoot as any;
        let dockerName = node.getAttribute('DocketName');
        if (dockerName === null || dockerName === undefined || dockerName === '')
            return '';
        return dockerName;
    }
    setLRONumber(lroNumber: string): void {
        let node = this.livedataRoot as any;
        if (lroNumber === null || lroNumber === undefined)
            return;
        node.setAttribute('LRO', lroNumber);
        node.setAttribute('isLROOverWrite', '1');
    }
    getLRONumber(): string {
        let node = this.livedataRoot as any;
        let lroNumber = node.getAttribute('LRO');
        if (lroNumber === null || lroNumber === undefined || lroNumber === '')
            return '';
        return lroNumber;
    }
    getDockerIdOverwriteFlag(): string {
        let node = this.livedataRoot as any;
        let flag = node.getAttribute('isDocketIDOverWrite');
        if (flag === undefined || flag === null || flag === '')
            return '';
        return flag;
    }
    getDockerNameOverwriteFlag(): string {
        let node = this.livedataRoot as any;
        let flag = node.getAttribute('isDocketNameOverWrite');
        if (flag === undefined || flag === null || flag === '')
            return '';
        return flag;
    }
    getLROOverwriteFlag(): string {
        let node = this.livedataRoot as any;
        let flag = node.getAttribute('isLROOverWrite');
        if (flag === undefined || flag === null || flag === '')
            return '';
        return flag;
    }
    setTeraviewTransfer(transfer: string): void {
        let node = this.livedataRoot as any;
        if (transfer === null || transfer === undefined || transfer === '')
            return;
        node.setAttribute('CreateTransfer', transfer);
    }
    setTeraviewTransferOption(transferOption: string): void {
        let node = this.livedataRoot as any;
        if (transferOption === null || transferOption === undefined || transferOption === '')
            return;
        node.setAttribute('ERegTransferType', transferOption);
    }
    getResideAtProperty(): string {
        let node = this.livedataRoot as any;
        let resideAtProperty = node.getAttribute('ResideAtProperty');
        if (resideAtProperty === null || resideAtProperty === undefined)
            return '';
        return resideAtProperty;
    }
    getPropertyType(): string {
        let node = this.livedataRoot as any;
        let propertyType = node.getAttribute('PropertyType');
        if (propertyType === null || propertyType === undefined)
            return '';
        return propertyType;
    }
    getVendorAddress(): string {
        let node = this.livedataRoot as any;
        let vendorAddress = node.getAttribute('VendorAddress');
        if (vendorAddress === null || vendorAddress === undefined)
            return '';
        return vendorAddress;
    }
    getbApplyToSpecificBuilding(): string {
        let node = this.livedataRoot as any;
        let bApplyToSpecificBuilding = node.getAttribute('getbApplyToSpecificBuilding');
        if (bApplyToSpecificBuilding === null || bApplyToSpecificBuilding === undefined)
            return '';
        return bApplyToSpecificBuilding;
    }
    getBuildingNumToMerge(): string {
        let node = this.livedataRoot as any;
        let buildingNumToMerge = node.getAttribute('buildingNumToMerge');
        if (buildingNumToMerge === null || buildingNumToMerge === undefined)
            return '';
        return buildingNumToMerge;
    }
    getCreateCharge(): string {
        let node = this.livedataRoot as any;
        let createCharge = node.getAttribute('CreateCharge');
        if (createCharge === null || createCharge === undefined)
            return '';
        return createCharge;
    }
    setCreateCharge(booleanStr: string): void {
        if (booleanStr === null || booleanStr === undefined)
            return;
        let node = this.livedataRoot as any;
        node.setAttribute('CreateCharge', booleanStr);
    }
    setCreateDischarge(booleanStr: string): void {
        if (booleanStr === null || booleanStr === undefined)
            return;
        let node = this.livedataRoot as any;
        node.setAttribute('CreateDischarge', booleanStr);
    }
    getCreateDischarge(): string {
        let node = this.livedataRoot as any;
        let createDischarge = node.getAttribute('CreateDischarge');
        if (createDischarge === null || createDischarge === undefined)
            return '';
        return createDischarge;
    }
    getERegTransferType(): string {
        let node = this.livedataRoot as any;
        let eregTransferType = node.getAttribute('ERegTransferType');
        if (eregTransferType === null || eregTransferType === undefined)
            return '';
        return eregTransferType;
    }
    getDocumentGeneral(): Array<XMLNode> {
        let node = this.livedataRoot as any;
        let docGeneral = getNodes(node, 'DocumentGeneral');
        return docGeneral;
    }
    getLawyerSaveMergeDocMode(): string {
        let lawyer = this.getFirstNode("lawyer");
        return lawyer?.attributes.SaveMergeDocMode;
    }
    getRegistryOfficeCode(): string {
        let node = this.livedataRoot as any;
        let municNode = node.selectSingleNode('munic');
        if (municNode === null || municNode === '' || municNode === undefined)
            return '';
        let registryOfficeNode = municNode.selectSingleNode('RegistryOffice');
        if (registryOfficeNode === null || registryOfficeNode === undefined || registryOfficeNode === '')
            return '';
        let registryOfficeCode = registryOfficeNode.getAttribute('OfficeCode');
        if (registryOfficeCode === null || registryOfficeCode === undefined || registryOfficeCode === '')
            return '';
        return registryOfficeCode;
    }
    getGuarantorInfo(): Array<XMLNode> {
        let node = (this.livedataRoot as any);
        let mortgageNodes: Array<XMLNode> = node.selectNodes("Mortgage");
        let retArr = [];
        for (let i = 0; i < mortgageNodes.length; i++) {
            let guarantorNodes = mortgageNodes[i].selectNodes('Guarantor');
            for (let j = 0; j < guarantorNodes.length; j++) {
                if (guarantorNodes[j].selectNodes('Identification').length > 0) {
                    retArr.push(guarantorNodes[j]);
                }
            }
        }
        return retArr;
    }
    getPriorOwnerInfo(): Array<PriorOwnerType> {
        let node = (this.livedataRoot as any);
        let retArray = [];
        let teranetConnectSearchNodes = node.selectSingleNode('TeranetConnect')?.selectNodes('TeranetConnectSearch');
        if (teranetConnectSearchNodes === null || teranetConnectSearchNodes === undefined)
            return [];
        for (let i = 0; i < teranetConnectSearchNodes.length; i++) {
            let instrumentNodes = teranetConnectSearchNodes[i].selectSingleNode('DoPurchase')?.selectSingleNode('ResponseBody')?.selectSingleNode('ParcelRegisterResponse')?.selectSingleNode('ParcelXML')?.selectSingleNode('parcel-register')?.selectSingleNode('instruments-list')?.selectNodes('instrument[type/short-description="TRANSFER"]');
            if (instrumentNodes === undefined || instrumentNodes === null) continue;
            for (let j = 0; j < instrumentNodes.length; j++) {
                let partyToList = instrumentNodes[j].selectSingleNode('party-to-list');
                if (partyToList === undefined || partyToList === null) continue;
                let partyToNodes = partyToList.selectNodes('party-to');
                for (let k = 0; k < partyToNodes.length; k++) {
                    if (partyToNodes[k].text !== null && partyToNodes[k].text !== '' && partyToNodes[k].text !== undefined) {
                        let found = retArray.some(ele => ele.name === partyToNodes[k].text);
                        if (!found)
                            retArray.push({ Name: partyToNodes[k].text });
                    }
                }
            }
        }
        return retArray;
    }
    getFileCreationDate(): string {
        return this.livedataRoot.getAttribute('CreationDate');
    }
    getContractDate(): string {
        return this.livedataRoot.getAttribute('ContractDate');
    }
    getLawyerReviewDate(): string {
        return this.livedataRoot.getAttribute('LawyerReviewDate');
    }
    getLawyerSoluno(): string {
        let ret = "";
        let purchaserLawyer = this.getNodeInfo("lawyer");
        if (purchaserLawyer.length > 0) {
            ret = purchaserLawyer[0].attributes["Soluno"] || "";
        }
        return ret;
    }
    getContractPrice(): string {
        return this.livedataRoot.getAttribute("PurchasePrice");
    }
    getIncludeHST(): string {
        return this.livedataRoot.getAttribute("IncludeGST");
    }
    setIncludeHST(val: string): void {
        this.livedataRoot.setAttribute("IncludeGST", val);
        runInnerFunction("SetPageDirty", null);
    }
    getHSTAmount(): string {
        return this.livedataRoot.getAttribute("GSTAmount");
    }
    getIncludeGSTInAccount(): string {
        let node = this.livedataRoot as any;
        const accNode = node.selectSingleNode("Account");
        if (accNode) {
            return accNode.getAttribute("IncludeGSTInAccount");
        }
        return null;
    }
    getGSTObject(province?: string): any {
        let node = this.livedataRoot as any;
        if (province === 'BC' || province === 'MB' || province === 'SK' || province === 'NS') {
            const skReader = new SKDataReader(this.livedataRoot);
            return skReader.getOtherProvinceTaxObject()
        }
        const accNode = node.selectSingleNode("Account");
        return {
            IncludeGST: this.getIncludeGSTInAccount(),
            GSTDisbursements: accNode?.getAttribute("GSTGSTDisbursements") ?? null,
            GSTFees: accNode?.getAttribute("GSTFee") ?? null
        };
    }
    getAssessmentRollNo(): string {
        let attributes = [
            this.livedataRoot.getAttribute("AssessmentRollNoCity") ?? "",
            this.livedataRoot.getAttribute("AssessmentRollNoMunicipality") ?? "",
            this.livedataRoot.getAttribute("AssessmentRollNoMap") ?? "",
            this.livedataRoot.getAttribute("AssessmentRollNoBlock") ?? "",
            this.livedataRoot.getAttribute("AssessmentRollNoParcel") ?? ""
        ];
        
        if (attributes.every(attr => attr === "")) {
            return null;
        }
        
        let assessmentRoll = attributes.join(" - ");
        return assessmentRoll;
    }
    setDepositTotalFromDeposit() {
        const nodes = this.getXMLList("Deposit");
        let depositTotal = 0;
        for (let i = 0; i < nodes.length; i++) {
            depositTotal += Number(nodes[i].getAttribute("Amount"));
        }
        this.livedataRoot.setAttribute("DepositTotal", String(depositTotal));
    }
    getDepositTotal(): string {
        const depositTotal = this.livedataRoot.getAttribute("DepositTotal");
        if (depositTotal !== null) {
            return this.livedataRoot.getAttribute("DepositTotal");
        } else {
            const nodes = this.getXMLList("Deposit");
            if (!nodes.length) return null;
            let depositTotal = 0;
            for (let i = 0; i < nodes.length; i++) {
                depositTotal += Number(nodes[i].getAttribute("Amount"));
            }
            return String(depositTotal);
        }
    }
    getVIPInfoMsgID(): string {
        if (!this.livedataRoot) return null;
        let vipNode = this.getNodeInfo("VIPInfo");
        if (vipNode.length > 0) {
            return vipNode[0].attributes['MsgID'];
        }
        return null;
    }
    getVIPInfoProjName(): string {
        if (!this.livedataRoot) return null;
        let vipNode = this.getNodeInfo("VIPInfo");
        if (vipNode.length > 0) {
            return vipNode[0].attributes['ProjectName'];
        }
        return null;
    }
    getVIPInfoSubFolder(): string {
        if (!this.livedataRoot) return null;
        let vipNode = this.getNodeInfo("VIPInfo");
        if (vipNode.length > 0) {
            return vipNode[0].attributes['SubFolder'];
        }
        return null;
    }
    getVIPInfoPassCode(): string {
        if (!this.livedataRoot) return null;
        let vipNode = this.getNodeInfo("VIPInfo");
        if (vipNode.length > 0) {
            return vipNode[0].attributes['PassCode'];
        }
        return null;
    }
    getTrustBank(): string {
        let node = this.livedataRoot as any;
        let lawyerNode = node.selectSingleNode('lawyer');
        return lawyerNode.getAttribute("TrustBank");
    }
    getTransitNumber(): string {
        let node = this.livedataRoot as any;
        let lawyerNode = node.selectSingleNode('lawyer');
        return lawyerNode.getAttribute("TransitNo");
    }
    getTrustNumber(): string {
        let node = this.livedataRoot as any;
        let lawyerNode = node.selectSingleNode('lawyer');
        return lawyerNode.getAttribute("TrustNo");
    }
    setReplyTo(val: number): void {
        this.livedataRoot.setAttribute("ReplyToFirmContact", val.toString());
    }

    getReplyTo(): number {
        return parseInt(this.livedataRoot.getAttribute("ReplyToFirmContact") || "0", 10);
    }

    setFieldsFromRecord(record: Record<string, any>): void {
        const appCode = this.getAppCode();
        const setXML = new SetXML(xmlMap, appCode);
        setXML.xml = this.livedataRoot;
        setXML.dataRPWDataReader = this;
        setXML.json = record;
        this.livedataRoot = setXML.transform();
    }
    getAllLawyer(): Array<PersonType> {
        let nodes = this.getNodeInfo("lawyer");
        return nodes.map(node => {return {Name: node.attributes.Name, personType: "lawyer", address: ""}})
        .filter(node => node.Name > "" && node.Name !== undefined);
    }
    getAllOtherLawyer(): Array<PersonType> {
        let nodes = this.getNodeInfo("Solicitor");
        return nodes.map(node => {return {Name: node?.attributes.Name, personType: node?.attributes.type, address: node?.attributes.Address}})
        .filter(val => val.Name > "" && val.Name !== undefined);
    }
    getMortgageLenderName(): Array<string> {
        let mortgages = this.getNodeInfo("Mortgage");
        return mortgages.map(node => node.attributes.Lender).filter(name => name !== undefined); 
    }
    getMortgageLenderPayee(): Array<{name: string, address: string}>{
        let mortgages = this.getNodeInfo("Mortgage");
        return mortgages.map(node => {
            let lenderNode = node?.children.find(node => node.name == "Lender")
            return {name: node?.attributes.Lender, address: lenderNode?.attributes.Address}
        }).filter(val => val.name > "" && val.name !== undefined); 
    }
    getMunicipalityPayee(): Array<{name: string, address: string}> {
        let extraProperties: Array<{name: string, address: string}> = [];
        if(this.getNodeInfo("Property").length){
            extraProperties = this.getNodeInfo("Property")[0]?.children.map(node => {
                let municNode = node.children.find(node => node.name == "munic");
                return {
                    name: municNode?.attributes.FullName, 
                    address: `${municNode?.attributes.MainAddress}, ${municNode?.attributes.MainAddressCity}, ${municNode?.attributes.MainPostalCode}`
                }
            }).filter(val => val.name > "" && val.name !== undefined);
        }
        let munic = this.getNodeInfo("munic").map(node => {
            return {
                name: node?.attributes.FullName, 
                address: `${node?.attributes.MainAddress}, ${node?.attributes.MainAddressCity}, ${node?.attributes.MainPostalCode}`
            }
        }).filter(val => val.name > "" && val.name !== undefined);

        return [].concat(munic, extraProperties);
    }
    getAllSurveyors(): Array<{name: string, address: string}> {
        let surveyors = ["Surveyor", "SurveyorNew"].map(nodeName => {
            let node = this.getNodeInfo(nodeName);
            return node.length?{name: node[0]?.attributes.Company, address: node[0]?.attributes.Address}:null;
        }).filter(val => val != null && val.name > "" && val.name !== undefined);
        // remove dupe if both surveyors are the same company
        if(surveyors.length > 1 && surveyors[0].name == surveyors[1].name){
            surveyors.pop();
        }
        return surveyors;
    }
    getAllPayees(): Array<PayeeType> {
        let allPayees = [];
        // buyers
        this.getBuyerPeopleInfo().map(val => {allPayees.push({name: val.Name, displayTitle: `Buyer`, address: val.AddressForService})});
        // seller
        this.getVendorInformation().map(val => {allPayees.push({name: val.Name, displayTitle: `Seller`, address: val.AddressForService})});
        // third party
        this.getThirdPartyInfo().map(val => {
            let title = val.personType=="OtherParty"? val.OtherPartyType:val.personType;
            let mappedTitle = {"InsuranceAgent": "Fire Insurance", "RealEstateAgent": "Listing Agent", "PurchaserRealEstateAgent": "Selling Agent"}[title]
            if(mappedTitle !== undefined) title = mappedTitle;
            let addr = val.address == undefined? "":val.address;
            allPayees.push({name: val.Name, displayTitle: title, address: addr})
        });
        // lawyer
        this.getAllLawyer().map(val => {allPayees.push({name: val.Name, displayTitle: `Responsible Lawyer`, address: val.address})});
        // other side lawyer
        this.getAllOtherLawyer().map(val => {allPayees.push({name: val.Name, displayTitle: `Other Side Lawyer`, address: val.address})});
        // mortgage lender
        this.getMortgageLenderName().map(val => {allPayees.push({name: val, displayTitle: `Mortgage Lender`})});
        // title insurance
        let insuranceProvider = this.getInsuranceInformation().insuranceProvider;
        if(insuranceProvider) allPayees.push({name: insuranceProvider, displayTitle: `Insurance Provider`});
        // municipality
        this.getMunicipalityPayee().map(val => {allPayees.push({name: val.name, displayTitle: `Municipality`, address: val.address})});

        return allPayees
    }
    getDefectMortgageSummary(): Array<MortgageSummaryType> {
        const DEFECT_ID = ["32_2", "32_1"];
        let defectMortgages = this.getNodeInfo("Defect").filter(node => DEFECT_ID.includes(node.attributes.type)).map((node, index) => {
            const dataNode = node.children.find(nodeElmt => nodeElmt.name === "Data");
            if(!dataNode) return null
            switch (node.attributes.type) {
                case "32_2":
                    const mortgageType = (dataNode?.attributes.ReqResult === "IssueToRemain") ? 'Remaining' : 'Discharge';
                    return {
                        lender: dataNode.attributes.Lender,
                        type: mortgageType,
                        amount: dataNode.attributes.PrincipalAmount,
                        ref: dataNode.attributes.MortgageReferenceNo,
                        advance: dataNode.attributes.PayoutAmount,
                        index: String(index),
                    } as MortgageSummaryType;
                case "32_1": // ON
                default:
                    return {
                        lender: dataNode.attributes.Lender,
                        type: "Assumed",
                        amount: dataNode.attributes.Amount,
                        ref: dataNode.attributes.RefNumber,
                        advance: dataNode.attributes.PayoutAmount,
                        index: String(index),
                    } as MortgageSummaryType;
            }
        }).filter(node => node != null && node.lender > "");
        return defectMortgages;
    }

    getAllMortgageSummary(): Array<MortgageSummaryType> {
        let mortgages = this.getNodeInfo("Mortgage").map(node => {
            return {
                lender: node.attributes.Lender,
                type: node.attributes.IsVTB === "1"? "VTB" : "New",
                amount: node.attributes.Amount,
                ref: node.attributes.LenderRefNo,
                advance: node.attributes.MTGProceeds,
                position: node.attributes.MortgagePositionCode,
            }
        }).filter(node => node.lender > "" && node.lender != undefined);

        let defectMortgages = this.getDefectMortgageSummary();
        return [].concat(mortgages, defectMortgages);
    }

    getRegistrationSummary(): Array<RegistrationSummaryType>{
        let transfer = this.getNodeInfo('Transfer');
        let registrationDetails: Array<RegistrationSummaryType> = [];
        if (transfer.length > 0) {
            let transferNode = transfer[0];
            registrationDetails = [{
                desc: "Transfer",
                date: transferNode.attributes?.RegistrationDate,
                instrumentNo: transferNode.attributes?.InstrumentNumber
            }]
        }
        let newMortgage: Array<RegistrationSummaryType> = this.getMortgageInformation()
            .map(node => {return {desc: "New Mortgage", date: node.registrationDate, instrumentNo: node.instrumentNumber}})
            // .filter(node => node.date != null && node.instrumentNo != null);

        let defectMortgage: Array<RegistrationSummaryType> = this.getNodeInfo('Defect')
            .filter(node => node.attributes.type === '32_2')
            .map(node => {
                let att = node.attributes;
                return {
                    desc: "Discharge Mortgage",
                    date: att.DischargeRegistrationDate,
                    instrumentNo: att.DischargeInstrumentNumber
                }
            })
            // .filter(node => node.date != null && node.instrumentNo != null);
        
        return [].concat(registrationDetails, newMortgage, defectMortgage);
    }

    getTitleInsuranceSummary(): TitleInsuranceSummaryType {
        let titleInsuranceNode = this.getNodeInfo("TitleInsurance");
        let atts = titleInsuranceNode[0]?.attributes;
        return {provider: atts?.Provider || "", status: atts?.OrderStatus || "", amount: atts?.AmmountPayable || "", policyNo: atts?.policyNumber || ""}
    }

    getHSTApplicable(): string {
        return this.livedataRoot.getAttribute("IsGSTApplicable");
    }

    setPID(PID: string){
        if(PID.match(/^([0-9]{3}-){2}[0-9]{3}$/)){   
            PID.split("-").forEach((num, index) => {
                this.livedataRoot?.setAttribute(`PID${index + 1}`, num)
            })
        } else {
            console.log("bad PID:", PID);
        }
    }

    getPID(): string {
        let sections = [];
        [1, 2, 3].forEach((index) => {
            let attr = this.livedataRoot?.getAttribute(`PID${index}`)
            if(attr) sections.push(attr);
        })
        return sections.join("-");
    }

    getSpouseNotOnTitleInfo(): { SpouseName: string | null, SpouseEmail: string | null }[] {
        const psm = this.getPSM();
        if (psm !== 'P' && psm !== 'S' && psm !== 'M') {
            return [];
        }
        
        const clients = psm === 'S' ? this.getVendorInformation() : this.getMortgagorInformation();
        
        if (!clients || clients.length === 0) {
            return [];
        }
        
        const results: { SpouseName: string | null, SpouseEmail: string | null }[] = [];
        
        for (let i = 0; i < clients.length; i++) {
            const person = clients[i];
            if (person.SpouseNotOnTitle && person.SpouseNotOnTitle !== '') {
                results.push({
                    SpouseName: person.SpouseNotOnTitle || null,
                    SpouseEmail: person.SpouseEmailAddress || null
                });
            }
        }
        
        return results;
    }

    setPurchaserAddress(address: string): void {
        this.livedataRoot?.setAttribute("PurchaserAddress", address)
    }

    setLastGmapAddressKey(address: string): void {
        this.livedataRoot?.setAttribute("LastGmapAddressKey", address)
    }

    getLastGmapAddressKey(): string {
        const propertyNode  = (this.livedataRoot as any)?.selectSingleNode("Property");
        return propertyNode?.getAttribute("LastGmapAddressKey") || "";
    }


    getExtraPropertiesAddress(): Array<string> {
        // function for BC
        return [];
    }

    getTitleSearchPinHistory(): Array<string> {
        let hist = this.getNodeInfo("TeranetHistory");
        let searches = hist[0]?.children.filter(node => node.attributes.type === "GetParcelRegister")
        return searches?.map(node => node.attributes.pin) || [];
    }

    getAllPins(): Array<string> {
        // no point duplicating logic just use allPins and split
        let allPinsS = this.getNodeInfo("LegalDescriptionInput")[0]?.attributes?.AllPINs;
        return allPinsS?.split(" ").map(pin => pin.replace(/[^0-9-]/, "")).filter(pin => pin.length == 10) || [];
    }

    getPurchaserSummary(): Array<PurchaserSummaryType> {
        return this.purchaserNodeSummary(this.getNodeInfo("Purchaser"));
    }

    getVendorSummary(): Array<PurchaserSummaryType> {
        return this.purchaserNodeSummary(this.getNodeInfo("Vendor"));
    }

    getMortgagerSummary(): Array<PurchaserSummaryType> {
        return this.getPurchaserSummary();
    }

    purchaserNodeSummary(list: XMLJSON[]): Array<PurchaserSummaryType>{
        const max = (arr: number[]): number => arr.reduce((p, c) => c>p?c:p, 0);
        return list.filter(node => node?.attributes?.Name > "").map(node => {
            let att = node.attributes
            let phoneNumber = node.children?.find(child => child.name === "ContactInfo" && ["Cell Phone", "Work Phone", "Home Phone"].includes(child.attributes?.ContactMethod) && child.attributes?.ContactMethodInfo > "")?.attributes?.ContactMethodInfo || "";
            let signOffNodes = node.children.filter(node => node.name === "SignOff").map(node => node.children.find(child => child.name === "Identification")).filter(node => node?.attributes?.type > "");
            let idNodes = node.children?.filter(node => node.name === "Identification").concat(signOffNodes);
            return {
                name: att?.Name,
                mainContact: att?.MainContact || "0",
                verifications: {
                    singleProcess: max(idNodes?.map(id => id.children?.filter(node => node?.name === "Verification" && node?.attributes?.Number > "" && node?.attributes?.ProcessOK === "Y").length)),
                    dualProcess: max(idNodes?.map(id => id.children?.filter(node => node?.name === "DualVerification" && node?.attributes?.Number > "" && node?.attributes?.ProcessOK === "Y").length)),
                },
                phone: phoneNumber || "",
                email: node.children?.find(child => child.name === "ContactInfo" && child.attributes?.ContactMethod === "Email" && child.attributes?.ContactMethodInfo > "")?.attributes?.ContactMethodInfo || "",
            }
        });
    }

    getFireInsuranceCompany(): string {
        return this.getNodeInfo("InsuranceAgent")[0]?.attributes?.SortName || "";
    }

    getThirdPartySummary(): Array<ThirdPartySummaryType> {
        let thirdParty = ["Conveyancer", "MortgageBroker", "InsuranceAgent", "RealEstateAgent", "PurchaserRealEstateAgent"].map(party => {
            let att = this.getNodeInfo(party)[0]?.attributes;
            return att && {
                name: att.Name || att.Company,
                type: party,
                company: att.Company,
                email: att.Email,
                phone: att.Phone,
                address: att.Address,
                personType: party as PopupPageId,
            }
        })
        let additionalParty = this.getNodeInfo("OtherParty").map((party, index) => {
            let att = party?.attributes;
            return att && {
                name: att.Name || att.Company,
                type: att.OtherPartyType,
                company: att.Company,
                email: att.Email,
                phone: att.Phone,
                address: att.Address,
                personType: "OtherParty" as PopupPageId,
                index: index + 1,
            }
        })
        return [...thirdParty, ...additionalParty].filter(party => party != undefined && party.name > "");
    }

    getWebFilings(): Array<string> { // not in ontario
        return [];
    }

    getLenderSolicitors(): Array<MortgageSolicitorType> {
        return this.getNodeInfo("Mortgage")?.map((node, index) => {
            if(node?.attributes.LenderHasLegalRepresentation !== "1") return null
            let solicitor = node?.children.find(child => child.name === "Solicitor");
            return {name: solicitor?.attributes.Name, lender: node?.attributes.Lender, email: solicitor?.attributes.FirmEmail, phone: solicitor?.attributes.DirectPhone, index: index + 1}
        }).filter(val => val?.name > "") || [];
    }

    getContactPersons(): Array<ContactType> {
        let solicitor = this.getNodeInfo("Solicitor")[0]?.children.filter(node => node?.name === "ContactPeople");
        return solicitor?.map(node => {return {name: node.attributes.ContactName, phone: node.attributes.ContactPhone, email: node.attributes.ContactEmail}}).filter(node => node.name > "") || [];
    }
    setIsUseStandardDocumentsOverwite() {
        let node = this.livedataRoot as any;
        node.setAttribute("isUseStandardDocumentsOverWrite", "1");
        let UseStandardDocuments = node.getAttribute('UseStandardDocuments');
        if (UseStandardDocuments === null || UseStandardDocuments === undefined || UseStandardDocuments === '0') {
            node.setAttribute("UseStandardDocuments", "1");
        } else {
            node.setAttribute("UseStandardDocuments", "0");
        }
        runInnerFunction("SetPageDirty", null);
    }
    setIsUseWesternProtocolOverwite() {
        let node = this.livedataRoot as any;
        let useWesternProtocol = node.getAttribute("UseWesternProtocol");
        if (useWesternProtocol === null || useWesternProtocol === undefined || useWesternProtocol === "0") {
            node.setAttribute("UseWesternProtocol", "1");
        } else {
            node.setAttribute("UseWesternProtocol", "0");
        }
        runInnerFunction("SetPageDirty", null);
    }
    getDefectUndertakings(): Array<DefectUndertakingType> {
        // let undertakings = this.getNodeInfo("Defect").filter(node => node.attributes.Undertaking === "1");
        // let s = undertakings.map(node => {
        //     if (!node.attributes.DefectId){
        //         const newId = uuidv4();
        //     }
        // })
        // return []
        // this.getClientEmail()
        const defects = (this.livedataRoot as any).selectNodes("Defect");
        defects.forEach(a => {
            console.log(a);
        })
        return []
    }

    getUndertaking(): any[] {
        let undertakings = []
        this.getNodeInfo('Defect').filter(node => node?.attributes.Undertaking === "1").forEach(node => {
            let data = node?.children.find(n => n.name === 'Data');
            if(data?.attributes.VendorLawyerUndertaking === '1' || this.getPSM() === "M"){
                let follow = data?.children.find(n => n.name === 'Followup');
                undertakings.push({
                    date1: follow?.attributes.Date1,
                    date2: follow?.attributes.Date2,
                    sentDate1: follow?.attributes.SentDate1,
                    sentDate2: follow?.attributes.SentDate2,
                    dueDate: follow?.attributes.DueDate,
                    id: node.attributes.DefectId,
                    completedDate: data?.attributes.DateCompliedWith,
                    name: node.attributes.name,
                    TaskComplete1: follow?.attributes.TaskComplete1,
                    TaskComplete2: follow?.attributes.TaskComplete2,
                    lender: data?.attributes.Lender,
                })
            }
        })
        return undertakings.filter(i => i.id > "");
    }
}


function selectNodesFunc(livedataRoot, nodeName: string): Array<XMLNode> {
    let retArr: Array<XMLNode>;
    nodeName === 'TPAppXML' ? retArr = [livedataRoot] : retArr = livedataRoot.selectNodes(nodeName);
    return retArr;
}

export function getContractInformation(livedataRoot: Element): { closingDate: string, propertyAddress: string } {
    return {
        'closingDate': livedataRoot.getAttribute("ClosingDate"),
        'propertyAddress': livedataRoot.getAttribute("PropertyAddress"),
    }
}

export function getLawyerNode(props) {
    return props?.dataroot?.selectSingleNode('lawyer');
}

export function getLawyerFullName(lawyerNode) {
    return lawyerNode?.getAttribute('SubUserFirstName') + ' ' + lawyerNode?.getAttribute('SubUserLastName');
}

export function getLawyerFirstName(lawyerNode) {
    return lawyerNode?.getAttribute('SubUserFirstName');
}

export function getLawyerLastName(lawyerNode) {
    return lawyerNode?.getAttribute('SubUserLastName');
}

export function getNodes(livedataRoot, nodeName: string): Array<XMLNode> {
    try {
        let retArr: Array<XMLNode> = selectNodesFunc(livedataRoot, nodeName);
        return retArr;
    } catch (e) {
        return null;
    }
}

export function XMLCheckNullAttributeValue(item: any, fieldname: string, defaultvalue: string) {
    if (item == null) {
        return defaultvalue;
    }
    else {
        if (item.getAttribute(fieldname) == null || item.getAttribute(fieldname) === "")
            return defaultvalue;
        else
            return item.getAttribute(fieldname);
    }
}

export function XMLCheckNullAttributeTextAreaFieldValue(item, fieldname: string, defaultvalue: string) {
    if (item == null) {
        return defaultvalue;
    }
    else {
        if (item.getAttribute(fieldname) == null || item.getAttribute(fieldname) === "" || item.getAttribute(fieldname).length < 6)
            return defaultvalue;
        else
            return item.getAttribute(fieldname);
    }
}

export function isNullValue(node, attribute): boolean {
    if (node == null) return true;
    if (attribute == null || attribute === '') return true;

    if (node.getAttribute(attribute) == null || node.getAttribute(attribute) === '') return true;
    return false;
}

export class ABDataReader extends ONDataReader implements RPWDataReader {
    getEarlyPossessionDate(): string {
        var ret = "";
        if (this.getPSM() !== "M") {
            ret = this.livedataRoot.getAttribute("EarlyPossessionDate")
        }
        return ret;
    }
    getFirmIncludedEmail(): string {
        let node = this.livedataRoot as any;
        let staffNode = node.selectSingleNode("Staff");
        if (staffNode) {
            return staffNode.getAttribute("Email");
        }
        return null;
    }
    getAllPins(): Array<string> {
        let pins = [];
        let n = this.getNodeInfo("LegalDescriptionInput");
        n.forEach(element => {
            pins.push(...element.children.filter(node => node.name === "LINC" && node.attributes.LINC).map(linc => linc.attributes.LINC || "") || [])
        });
        return pins;
    }
    setIsUseWesternProtocolOverwite() {
        let node = this.livedataRoot as any;
        let useWesternProtocol = node.getAttribute("UseWesternProtocol");
        if (useWesternProtocol === null || useWesternProtocol === undefined || useWesternProtocol === "0") {
            node.setAttribute("UseWesternProtocol", "1");
        } else {
            node.setAttribute("UseWesternProtocol", "0");
        }
        runInnerFunction("SetPageDirty", null);
    }
}
export class SKDataReader extends ONDataReader implements RPWDataReader {
    getOtherProvinceTaxObject(): any {
        let node = this.livedataRoot as any;
        const accNode = node.selectSingleNode("Account");
        return {
            IncludePSTFee: accNode?.getAttribute("IsTaxablePST") ?? "0",
            IncludeGSTFee: (accNode?.getAttribute("TaxesOnFees") != "0.00") ? "1" : "0",
            GSTFee: accNode?.getAttribute("TaxesOnFees") ?? "0",
            PSTFee: accNode?.getAttribute("PSTOnFees") ?? "0",
            DisbTaxes: accNode?.getAttribute("TaxesOnTaxableDisbursements") ?? "0",
            DisbTaxesSK: accNode?.getAttribute("TaxesOnTaxableItems") ?? "0",
            GSTOnOtherItems: accNode?.getAttribute("GSTOnOtherItems") ?? "0",
            PSTOnOtherItems: accNode?.getAttribute("PSTOnOtherItems") ?? "0",
        };
    }
    setLegalDesc(nodes: any): void {
        this.exclusiveAppendNodes("LegalDescriptionInput", nodes); 
        runInnerFunction("SetPageDirty", null);
    }
    getXMLList(type: string): any {
        let nodes = null;
        switch (type) {
            case "TransfereeDetails":
                nodes = (this.livedataRoot as any).selectNodes(`APSNames[@Type='${this.getPSM() === "M" ? "Mortgagors" : "Purchasers"}']/Name`);
                break;
            case "TransferorDetails":
                nodes = (this.livedataRoot as any).selectNodes("APSNames[@Type='Vendors']/Name");
                break;
            case "Mortgages":
                nodes = (this.livedataRoot as any).selectNodes("Mortgage");
                break;
            case "SimiliarNames":
                nodes = (this.livedataRoot as any).selectNodes("Defect[contains(@type,'21')]");
                break;
            case "VIPInfo":
                nodes = (this.livedataRoot as any).selectNodes("VIPInfo");
                break;
            case "Deposit":
                nodes = (this.livedataRoot as any).selectNodes("Deposit");
                break;
            case "LegalDescriptionInput":
                nodes = (this.livedataRoot as any).selectNodes("LegalDescriptionInput");
                break;
            case "Property":
                nodes = (this.livedataRoot as any).selectNodes("Property");
                break;
            case "munic":
                nodes = (this.livedataRoot as any).selectNodes("munic");
                break;
            case "PurchaserBankingInfo":
                nodes = (this.livedataRoot as any).selectNodes("APSNames[@Type='Purchasers']/BankingInfo");
                break;
        }
        return nodes;
    }
    addNewVendor(name: string, type?: string): any {
        let node = this.livedataRoot as any;
        let provShort = this.getAppCode();
        let provName = getProvinceFullName(provShort);
        let person = node.parentNode.ownerDocument.createElement("Name");
        let identification = person.ownerDocument.createElement("Identification");
        person.appendChild(identification);
        identification.setAttribute("type", "I");
        identification.setAttribute("Name", name ?? "");
        identification.setAttribute("NameType", "Transferor");
        if (type !== "Person" || type === null) {
            person.setAttribute("Gender", "Corporation");
            person.setAttribute("OnAgreementName", name ?? "");
        } else {
            // Split the full name into first, middle, and last
            const nameParts = (name ?? "").split(' ');
            const firstName = nameParts[0] || '';
            const lastName = nameParts[nameParts.length - 1] || '';
            const middleName = nameParts.slice(1, -1).join(' ') || '';

            // Set individual name attributes
            person.setAttribute("OnAgreementFirstName", firstName);
            person.setAttribute("OnAgreementMiddleName", middleName);
            person.setAttribute("OnAgreementLastName", lastName);
        }
        person.setAttribute("OnAgreement", "1");
        person.setAttribute("OnTitle", "1");
        person.setAttribute("OnTitleNameFull", name ?? "");
        person.setAttribute("Province", provName);
        person.setAttribute("ProvinceName", provName);
        (this.livedataRoot as any).selectSingleNode("APSNames[@Type='Vendors']").appendChild(person);
        return person;
    }
    addNewPurchaser(name: string | null, type?: string): any {
            let node = this.livedataRoot as any;
            let provShort = this.getAppCode();
            let provName = getProvinceFullName(provShort);
            let person = node.parentNode.ownerDocument.createElement("Name");
            let identification = person.ownerDocument.createElement("Identification");
            person.appendChild(identification);
            identification.setAttribute("type", "I");
            identification.setAttribute("Name", name ?? "");
            identification.setAttribute("NameType", "Transferee");
        if (type !== "Person" || type === null) {
            person.setAttribute("Gender", "Corporation");
            person.setAttribute("OnAgreementName", name ?? "");
        } else {
            // Split the full name into first, middle, and last
            const nameParts = (name ?? "").split(' ');
            const firstName = nameParts[0] || '';
            const lastName = nameParts[nameParts.length - 1] || '';
            const middleName = nameParts.slice(1, -1).join(' ') || '';

            // Set individual name attributes
            person.setAttribute("OnAgreementFirstName", firstName);
            person.setAttribute("OnAgreementMiddleName", middleName);
            person.setAttribute("OnAgreementLastName", lastName);
        }
        person.setAttribute("OnAgreement", "1");
        person.setAttribute("OnTitle", "1");
        person.setAttribute("OnTitleNameFull", name ?? "");
        person.setAttribute("Province", provName);
        person.setAttribute("ProvinceName", provName);
        (this.livedataRoot as any).selectSingleNode("APSNames[@Type='Purchasers']").appendChild(person);
        return person;
    }
    getVendorInformation(): Array<VendorType> {
        let appcode = this.livedataRoot.getAttribute("ApplicationSubCode");
        let apsNames = this.getNodeInfo("APSNames")
            .find(node => node.attributes.Type === "Vendors")
        let vendors = apsNames.children.filter((node) => node.name === "Name")
            .filter((node) => node.attributes.OnTitleName > "" || node.attributes.OnAgreementName > "")
            .map(node => {
                let att = node.attributes;
                return {
                    IsVendor: att.OnAgreement,
                    OnTitle: att.OnTitle,
                    Name: (att.OnTitleNameFull > "") ? att.OnTitleNameFull : "blank",
                    personType: "Vendor",
                    TransferorNameFull: (appcode === "ON" || appcode === "AB" ?
                        (att.TransferorNameFull > "") ? att.TransferorNameFull : att.Name :
                        appcode === "NS" ?
                            (att.OnTitleNameFull > "") ? att.OnTitleNameFull : att.OnTitleName :
                            null
                    ),
                    TransferorName: att.TransferorName,
                    Gender: att.Gender,
                    AddressForService: att.AddressForService,
                    HSTNumber: att.GSTNumber,
                    OnAgreementName: att.OnAgreementName,
                    SpouseNotOnTitle: att.SpouseNotOnTitle,
                    SpouseEmailAddress: att.SpouseEmailAddress,
                }
            }
            );
        let results = vendors.filter((vendor) => vendor.Name !== "blank");
        return results;
    }
    getMortgagorInformation(): Array<PurchaserType> {
        let appcode = this.livedataRoot.getAttribute("ApplicationSubCode");
        let apsNames = this.getNodeInfo("APSNames")
            .find(node => node.attributes.Type === (this.getPSM() === "M" ? "Mortgagors" : "Purchasers"))
        let purchaser = apsNames.children.filter((node) => node.name === "Name")
            .filter((node) => node.attributes.OnTitleName > "" || node.attributes.OnAgreementName > "")
            .map(node => {
                let att = node.attributes;
                return {
                    IsPurchaser: att.OnAgreement,
                    OnTitle: att.OnTitle,
                    Name: (att.OnTitleNameFull > "") ? att.OnTitleNameFull : "blank",
                    personType: "Purchaser",
                    AddressForService: (att.AddressForService > "") ? att.AddressForService : "",
                    TransfereeNameFull:
                        (appcode === "ON" || appcode === "AB" ?
                            (att.TransfereeNameFull > "") ? att.TransfereeNameFull : att.Name :
                            appcode === "NS" || appcode === "BC" ?
                                (att.OnTitleNameFull > "") ? att.OnTitleNameFull : att.OnTitleName :
                                null
                        ),
                    Birthday: att.BirthDate,
                    Gender: att.Gender,
                    TransfereeName: (appcode === "ON" || appcode === "AB" ?
                    (att.TransfereeName > "") ? att.TransfereeName : att.Name :
                    appcode === "NS" || appcode === "BC" ?
                        (att.OnTitleName > "") ? att.OnTitleName : att.OnTitleName :
                        null
                    ),
                    SpouseNotOnTitle: att.SpouseNotOnTitle,
                    SpouseEmailAddress: att.SpouseEmailAddress,
                }
            }
            );

        let results = purchaser.filter((person) => person.Name !== "blank");
        return results;
    }
    setIndividual(nodeType: string, pos: number): boolean {
        let node = this.livedataRoot as any
        if (nodeType !== PopupPageId.Transferee && nodeType !== PopupPageId.Transferor) {
            return false
        }
        const nodeString = nodeType === PopupPageId.Transferee ? (this.getPSM() === "M" ? "Mortgagors" : "Purchasers") : "Vendors"
        let person = node.selectSingleNode(`APSNames[@Type="${nodeString}"]/Name[${pos}]`)
        if (person) {
            person.setAttribute("Gender", "")
            runInnerFunction(nodeType === PopupPageId.Transferee ? "ReactShell.reactSelectMortgagor" : "ReactShell.reactSelectVendor", pos);
            return true;
        } else {
            return false;
        }
    }
    setCorporation(nodeType: string, pos: number): boolean {
        let node = this.livedataRoot as any;
        if (nodeType !== PopupPageId.Transferee && nodeType !== PopupPageId.Transferor) {
            return false;
        }
        const nodeString = nodeType === PopupPageId.Transferee ? (this.getPSM() === "M" ? "Mortgagors" : "Purchasers") : "Vendors";
        let person = node.selectSingleNode(`APSNames[@Type="${nodeString}"]/Name[${pos}]`);
        if (person) {
            person.setAttribute("Gender", "Corporation");
            runInnerFunction(nodeType === PopupPageId.Transferee ? "ReactShell.reactSelectMortgagor" : "ReactShell.reactSelectVendor", pos);
            return true;
        } else {
            return false;
        }
    }
    setEstate(nodeType: string, pos: number): boolean {
        let node = this.livedataRoot as any;
        if (nodeType !== PopupPageId.Transferee && nodeType !== PopupPageId.Transferor) {
            return false;
        }
        const nodeString = nodeType === PopupPageId.Transferee ? (this.getPSM() === "M" ? "Mortgagors" : "Purchasers") : "Vendors";
        let person = node.selectSingleNode(`APSNames[@Type="${nodeString}"]/Name[${pos}]`);
        if (person) {
            person.setAttribute("IsEstate", "1");
            person.setAttribute("Gender", "");
            runInnerFunction(nodeType === PopupPageId.Transferee ? "ReactShell.reactSelectMortgagor" : "ReactShell.reactSelectVendor", pos);
            return true;
        } else {
            return false;
        }
    }
    getClientContactInfo(province: string, skip?: boolean) {
        var retVal: any[] = [];
        var psm = this.getPSM();
        var apsNames = (this.livedataRoot as any).selectNodes('APSNames');
        
        // Function to process user info and collect emails
        const processUserInfo = (userInfo) => {
            for (let i = 0; i < userInfo.length - 1; i++) {
                var contactInfo = userInfo[i].selectNodes('ContactInfo');
                for (let j = 0; j < contactInfo.length; j++) {
                    if (contactInfo[j].getAttribute('ContactMethod') === "Email") {
                        var email = contactInfo[j].getAttribute('ContactMethodInfo');
                        if (email) {
                            retVal.push(email);
                        }
                    }
                }
            }
        };
    
        // Find the correct APSNames node based on Type
        for (let i = 0; i < apsNames.length; i++) {
            if (psm === "S" && apsNames[i].getAttribute('Type') === "Vendors") {
                var userInfo = apsNames[i].selectNodes('Name');
                processUserInfo(userInfo);
                break;
            } else if (psm === "M" && apsNames[i].getAttribute('Type') === "Mortgagors") {
                var userInfo = apsNames[i].selectNodes('Name');
                processUserInfo(userInfo);
                break;
            } else if (psm === "P" && apsNames[i].getAttribute('Type') === "Purchasers") {
                var userInfo = apsNames[i].selectNodes('Name');
                processUserInfo(userInfo);
                break;
            }
        }
    
        if (retVal.length > 0) {
            return retVal;
        } else if (!skip) {
            alert("Please set an email for each user to get notified about any updates")
        }
    }
    
    getSpouseNotOnTitleInfo(): { SpouseName: string | null, SpouseEmail: string | null }[] {
        const psm = this.getPSM();
        if (psm !== 'P' && psm !== 'S' && psm !== 'M') {
            return [];
        }
        
        const clients = psm === 'S' ? this.getVendorInformation() : this.getMortgagorInformation();
        
        if (!clients || clients.length === 0) {
            return [];
        }
        
        const results: { SpouseName: string | null, SpouseEmail: string | null }[] = [];
        
        for (let i = 0; i < clients.length; i++) {
            const person = clients[i];
            if (person.SpouseNotOnTitle && person.SpouseNotOnTitle !== '') {
                results.push({
                    SpouseName: person.SpouseNotOnTitle || null,
                    SpouseEmail: person.SpouseEmailAddress || null
                });
            }
        }
        
        return results;
    }
    getClientEmail() {
        var retVal: any[] = [];
        var psm = this.getPSM();
        var apsNames = (this.livedataRoot as any).selectNodes('APSNames');
        
        // Function to process user info and collect emails
        const processUserInfo = (userInfo) => {
            for (let i = 0; i < userInfo.length; i++) {
                var name = userInfo[i].getAttribute('OnTitleNameFull');
                var contactInfo = userInfo[i].selectNodes('ContactInfo');
                for (let j = 0; j < contactInfo.length; j++) {
                    if (contactInfo[j].getAttribute('ContactMethod') === "Email") {
                        var email = contactInfo[j].getAttribute('ContactMethodInfo');
                        if (email) {
                            retVal.push({name, email});
                        }
                    }
                }
            }
        };
    
        // Find the correct APSNames node based on Type
        for (let i = 0; i < apsNames.length; i++) {
            if (psm === "S" && apsNames[i].getAttribute('Type') === "Vendors") {
                var userInfo = apsNames[i].selectNodes('Name');
                processUserInfo(userInfo);
                break;
            } else if (psm === "M" && apsNames[i].getAttribute('Type') === "Mortgagors") {
                var userInfo = apsNames[i].selectNodes('Name');
                processUserInfo(userInfo);
                break;
            } else if (psm === "P" && apsNames[i].getAttribute('Type') === "Purchasers") {
                var userInfo = apsNames[i].selectNodes('Name');
                processUserInfo(userInfo);
                break;
            }
        }
    
        if (retVal.length > 0) {
            return retVal;
        }
    }
    getAllPins(): Array<string> {
        let parcels = this.getNodeInfo("LegalDescriptionInput").filter(node => node.attributes?.ParcelNum);

        return [].concat(...parcels.map(node => 
            node?.children?.filter(child => child.name === "TitleNumber" && child.attributes.TitleNumber)
            .map(child => `[${child.attributes.TitleNumber} (${node.attributes.ParcelNum})]`)));
    }
    getPurchaserSummary(): Array<PurchaserSummaryType> {
        let purchaserNodes = this.getNodeInfo("APSNames").find(node => node?.attributes?.Type === "Purchasers")?.children?.filter(
            child => child?.name === "Name") || [];
        return this.purchaserNodeSummary(purchaserNodes);
    }
    getVendorSummary(): Array<PurchaserSummaryType> {
        let vendorNodes = this.getNodeInfo("APSNames").find(node => node?.attributes?.Type === "Vendors")?.children?.filter(
            child => child?.name === "Name") || [];
        return this.purchaserNodeSummary(vendorNodes);
    }
    getMortgagerSummary(): Array<PurchaserSummaryType> {
        let mortgagerNodes = this.getNodeInfo("APSNames").find(node => node?.attributes?.Type === "Mortgagors")?.children?.filter(
            child => child?.name === "Name") || [];
        return this.purchaserNodeSummary(mortgagerNodes);
    }
    purchaserNodeSummary(list: XMLJSON[]): Array<PurchaserSummaryType>{
        return list.filter(node => node?.attributes?.OnAgreementName > "").map(node => {
            let att = node?.attributes
            let phoneNumbers = ["Cell Phone", "Work Phone", "Home Phone"].map(
                phone => node.children?.find(child => child.name === "ContactInfo" && child.attributes?.ContactMethod === phone && child.attributes?.ContactMethodInfo > "")?.attributes?.ContactMethodInfo || "")
            let signOffNodes = node.children.filter(node => node.name === "SignOff").map(node => node.children.find(child => child.name === "Identification")).filter(node => node?.attributes?.type > "");
            let idNodes = node.children?.filter(node => node.name === "Identification").concat(signOffNodes);
            return {
                name: att?.OnAgreementNameFull,
                mainContact: att?.MainContact || "0",
                verifications: {
                    singleProcess: idNodes?.map(id => id.children?.filter(node => node?.name === "Verification" && node?.attributes?.Number > "" && node?.attributes?.ProcessOK === "Y").length).reduce((p, c) => c>p?c:p, 0),
                    dualProcess: idNodes?.map(id => id.children?.filter(node => node?.name === "DualVerification" && node?.attributes?.Number > "" && node?.attributes?.ProcessOK === "Y").length).reduce((p, c) => c>p?c:p, 0),
                },
                phone: phoneNumbers.find(number => number > "") || "",
                email: node.children?.find(child => child.name === "ContactInfo" && child.attributes?.ContactMethod === "Email" && child.attributes?.ContactMethodInfo > "")?.attributes?.ContactMethodInfo || "",
            }
        });
    }
    getDefectMortgageSummary(): Array<MortgageSummaryType> {
        const DEFECT_ID = ["32_2"];
        let defectMortgages = this.getNodeInfo("Defect").filter(node => DEFECT_ID.includes(node.attributes.type)).map((node, index) => {
            const dataNode = node.children.find(nodeElmt => nodeElmt.name === "Data");
            if(!dataNode) return null
            switch (node.attributes.type) {
                case "32_2":
                default:
                    return {
                        lender: dataNode.attributes.Lender,
                        type: "Discharge",
                        amount: dataNode.attributes.Amount1,
                        ref: dataNode.attributes.MortgageReferenceNo,
                        advance: dataNode.attributes.PayoutAmount,
                        index: String(index),
                    } as MortgageSummaryType;
            }
        }).filter(node => node != null && node.lender > "");
        return defectMortgages;
    }
    getRegistrationSummary(): Array<RegistrationSummaryType> {
        let newMortgage: Array<RegistrationSummaryType> = this.getMortgageInformation()
            .map(node => {return {desc: "New Mortgage", date: node.registrationDate, instrumentNo: node.instrumentNumber}})
            // .filter(node => node.instrumentNo > "");
        let newInstrument: Array<RegistrationSummaryType> = this.getNodeInfo('NewInstrument').map(node => {return {
            desc: "New Interest",
            date: node.attributes.RegistrationDate,
            instrumentNo: node.attributes.InstrumentNumber,
        }})
        let defectMortgage: Array<RegistrationSummaryType> = this.getNodeInfo('Defect')
            .filter(node => node.attributes.type === '32_2')
            .map(node => {
                let att = node.attributes;
                return {
                    desc: "Discharge Mortgage",
                    date: att.DischargeRegistrationDate,
                    instrumentNo: node.children.find(child => child.name === "Data").attributes.InstrumentNumber,
                }
            })
        return [...newMortgage, ...newInstrument, ...defectMortgage];
    }
    setIsUseWesternProtocolOverwite() {
        let node = this.livedataRoot as any;
        let useWesternProtocol = node.getAttribute("UseWesternProtocol");
        if (useWesternProtocol === null || useWesternProtocol === undefined || useWesternProtocol === "0") {
            node.setAttribute("UseWesternProtocol", "1");
        } else {
            node.setAttribute("UseWesternProtocol", "0");
        }
        runInnerFunction("SetPageDirty", null);
    }
}
export class BCDataReader extends SKDataReader implements RPWDataReader {
    getEarlyPossessionDate(): string {
        let ret = "";
        if (this.getPSM() !== "M") {
            ret = this.livedataRoot.getAttribute("EarlyPossessionDate")
        }
        return ret;
    }
    getLawyerShowSellerAdjustmentsNew(): string {
        let ret = "";
        let purchaserLawyer = this.getNodeInfo("lawyer");
        ret = purchaserLawyer[0].attributes["showSellerAdjustmentsNew"]
        return ret;
    }
    getExtraPropertiesAddress(): Array<string> {
        let propertyNode = this.getNodeInfo("Property");
        let extraPropertynodes = propertyNode.length?propertyNode[0]?.children.filter(node => node.name === "Property"):[];
        return extraPropertynodes.map(node => {return node?.attributes?.PropertyAddress || ""});
    }
    getTitleSearchPinHistory(): Array<string> {
        let ltsaNode = this.getNodeInfo("TitleImport")[0];
        let searches = ltsaNode?.children?.filter(node => {return node?.name === "LTSASearch" && node?.attributes?.SearchAction === "getIndefeasibleTitle"});
        return searches?.map(node => node?.attributes?.PID) || [];
    }
    getAllPins(): Array<string> {
        let PID = this.getPID();
        let mainPID = PID?[PID]:[];
        let extraPIDs = this.getNodeInfo("Property")[0]?.children?.filter(node => node.name === "Property").map(
            extraP => [1, 2, 3].map(index => extraP.attributes[`PID${index}`] || "").join("-")            
        ).filter(pid => pid.length == 11) || [];
        return [...mainPID, ...extraPIDs];
    }
    getWebFilings(): Array<string> {
        return this.getNodeInfo("TitleImport")[0]?.children?.filter(child => child.name === "Package")?.map(node => node?.attributes?.packageDescription) || [];
    }
    getDefectInformation(): Array<Record<string, string>> {
        let defectInfo = this.getNodeInfo("Defect")
            .filter((matter) => {
                const isImported = matter.attributes?.CreatedFromImport === "1";
                const isVerified = matter.attributes?.IssueTypeVerified === "1";
                return !isImported || isVerified;
            });
        for (let matter of defectInfo) {
            matter.attributes.ReqResult = matter.children.find(node => node.name === "Data")?.attributes.EnqResult;
        }
        return defectInfo.map(node => node.attributes)
    }
    getRequisitionSentDate(): string {
        return this.livedataRoot.getAttribute("RequisitionResponseDate");
    }
}
export class MBDataReader extends SKDataReader implements RPWDataReader {
    getAllPins(): Array<string> {
        return this.getNodeInfo("LegalDescriptionInput").map(node => node.attributes?.ParcelNum).filter(val => val > "");
    }
    getDefectInformation(): Array<Record<string, string>> {
        let defectInfo = this.getNodeInfo("Defect")
        for (let matter of defectInfo) {
            if (matter.children.find(node => node.name === "Data")?.attributes['ReqResult'] === "Resolved") {
                matter.attributes['CheckResolved'] = '1';
            } else {
                matter.attributes['CheckResolved'] = '0';
            }
            if (matter.children.find(node => node.name === "Data")?.attributes['ReqResult']) {
                matter.attributes['ReqResult'] = matter.children.find(node => node.name === "Data")?.attributes['ReqResult'];
            }
        }

        return defectInfo.map(node => node.attributes)
    }
    getDefectMortgageSummary(): Array<MortgageSummaryType> {
        const DEFECT_ID = ["32_1", "32_2"];
        let defectMortgages = this.getNodeInfo("Defect").filter(node => DEFECT_ID.includes(node.attributes.type)).map((node, index) => {
            const dataNode = node.children.find(nodeElmt => nodeElmt.name === "Data");
            if(!dataNode) return null
            switch (node.attributes.type) {
                case "32_2":
                    return {
                        lender: dataNode.attributes.Lender,
                        type: "Discharge",
                        amount: dataNode.attributes.InitialPayoutAmount,
                        ref: dataNode.attributes.MortgageReferenceNo,
                        advance: dataNode.children.find(node => node.name === "IssuePayout")?.attributes.Amount,
                        index: String(index),
                    } as MortgageSummaryType;
                case "32_1":
                    return {
                        lender: dataNode.attributes.Lender,
                        type: "Assumed",
                        amount: dataNode.children.find(node => node.name === "IssueAdjust")?.attributes.Amount,
                        ref: dataNode.attributes.MortgageReferenceNo,
                        advance: dataNode.children.find(node => node.name === "IssueAdjust")?.attributes.AmountToAdjust,
                        index: String(index),
                    } as MortgageSummaryType;
            }
        }).filter(node => node != null && node.lender > "");
        return defectMortgages;
    }
}

export class NSDatareader extends SKDataReader implements RPWDataReader {
    getLawyerReviewDate(): string {
        return this.livedataRoot.getAttribute('LawyerReviewDate');
    }
    addNewVendor(name: string, type?: string): any {
        let node = this.livedataRoot as any;
        let provShort = this.getAppCode();
        let provName = getProvinceFullName(provShort);
        let person = node.parentNode.ownerDocument.createElement("Name");
        let identification = person.ownerDocument.createElement("Identification");
        person.appendChild(identification);
        identification.setAttribute("type", "I");
        identification.setAttribute("Name", name ?? "");
        identification.setAttribute("NameType", "Transferor");
        if (type !== "Person" || type === null) {
            person.setAttribute("Gender", "Corporation");
        }
        person.setAttribute("OnAgreementName", name ?? "");
        person.setAttribute("OnAgreement", "1");
        person.setAttribute("OnTitle", "1");
        person.setAttribute("OnTitleNameFull", name ?? "");
        person.setAttribute("Province", provName);
        person.setAttribute("ProvinceName", provName);
        (this.livedataRoot as any).selectSingleNode("APSNames[@Type='Vendors']").appendChild(person);
        return person;
    }
    addNewPurchaser(name: string | null, type?: string): any {
            let node = this.livedataRoot as any;
            let provShort = this.getAppCode();
            let provName = getProvinceFullName(provShort);
            let person = node.parentNode.ownerDocument.createElement("Name");
            let identification = person.ownerDocument.createElement("Identification");
            person.appendChild(identification);
            identification.setAttribute("type", "I");
            identification.setAttribute("Name", name ?? "");
            identification.setAttribute("NameType", "Transferee");
        if (type !== "Person" || type === null) {
            person.setAttribute("Gender", "Corporation");
        }
        person.setAttribute("OnAgreementName", name ?? "");
        person.setAttribute("OnAgreement", "1");
        person.setAttribute("OnTitle", "1");
        person.setAttribute("OnTitleNameFull", name ?? "");
        person.setAttribute("Province", provName);
        person.setAttribute("ProvinceName", provName);
        (this.livedataRoot as any).selectSingleNode("APSNames[@Type='Purchasers']").appendChild(person);
        return person;
    }
    getAllPins(): Array<string> {
        let propertyType = this.getPropertyType();
        let legalNode = this.getNodeInfo("LegalDescriptionInput")[0];
        if(propertyType === "Condo"){
            return legalNode?.children?.filter(node => node.name === "Unit" && node.attributes.PINBlock).map(node => node.attributes.PINBlock) || [];
        }
        return legalNode?.children?.find(node => node.name === "Lot")?.children.filter(lot => lot.name === "LotPIN" && lot.attributes.PINBlock)
        .map(node => node.attributes.PINBlock) || []
    }
    getDefectInformation(): Array<Record<string, string>> {
        let defectInfo = this.getNodeInfo("Defect")
        for (let matter of defectInfo) {
            if (matter.children.find(node => node.name === "Data")?.attributes['ReqResult'] === "Resolved") {
                matter.attributes['CheckResolved'] = '1';
            } else {
                matter.attributes['CheckResolved'] = '0';
            }
            if (matter.children.find(node => node.name === "Data")?.attributes['ReqResult']) {
                matter.attributes['ReqResult'] = matter.children.find(node => node.name === "Data")?.attributes['ReqResult'];
            }
        }

        return defectInfo.map(node => node.attributes)
    }
    getDefectMortgageSummary(): Array<MortgageSummaryType> {
        const DEFECT_ID = ["32_2"];
        let defectMortgages = this.getNodeInfo("Defect").filter(node => DEFECT_ID.includes(node.attributes.type)).map((node, index) => {
            const dataNode = node.children.find(nodeElmt => nodeElmt.name === "Data");
            if(!dataNode) return null
            switch (node.attributes.type) {
                case "32_2":
                default:
                    return {
                        lender: dataNode.attributes.Lender,
                        type: "Discharge",
                        amount: dataNode.attributes.InitialPayoutAmount,
                        ref: dataNode.attributes.MortgageReferenceNo,
                        advance: dataNode.attributes.PayoutAmount,
                        index: String(index),
                    } as MortgageSummaryType;
            }
        }).filter(node => node != null && node.lender > "");
        return defectMortgages;
    }

    getRegistrationSummary(): Array<RegistrationSummaryType>{
        let transfer = this.getNodeInfo('Transfer');
        let registrationDetails: Array<RegistrationSummaryType> = [];
        if (transfer.length > 0) {
            let transferNode = transfer[0];
            registrationDetails = [{
                desc: "Transfer",
                date: transferNode.attributes?.RegistrationDate,
                instrumentNo: transferNode.attributes?.InstrumentNumber
            }]
        }
        let newMortgage: Array<RegistrationSummaryType> = this.getMortgageInformation()
            .map(node => {return {desc: "New Mortgage", date: node.registrationDate, instrumentNo: node.instrumentNumber}})
            // .filter(node => node.date != null && node.instrumentNo != null);

        let defectMortgage: Array<RegistrationSummaryType> = this.getNodeInfo('Defect')
            .filter(node => node.attributes.type === '32_2')
            .map(node => {
                let att = node.attributes;
                return {
                    desc: "Discharge Mortgage",
                    date: att.DischargeRegistrationDate,
                    instrumentNo: att.DischargeInstrumentNumber
                }
            })
            // .filter(node => node.date != null && node.instrumentNo != null);
        return [].concat(registrationDetails, newMortgage, defectMortgage);
    }
}

export class DRDataReader {
    livedataRoot: Element;
    constructor(livedataRoot: Element) {
        this.livedataRoot = livedataRoot;
    }
    getFileNumber(): string {
        let node = this.livedataRoot as any;
        const ret = node.runXpath("Project/@ProjectName");
        return ret;
    }
    getSellerLawyerName(): string {
        let node = this.livedataRoot as any;
        const ret = node.runXpath("Project/lawyer/@Name");
        return ret;
    }
    getSellerFirmContact(): string {
        let node = this.livedataRoot as any;
        const ret = node.runXpath("Project/Staff/@Name");
        return ret;
    }
    getBuyerLawyerName(): string {
        let node = this.livedataRoot as any;
        const ret = node.runXpath("@BuyerName");
        return ret;
    }
    getBuyerMainContactName(): Array<string> {
        let node = this.livedataRoot as any;
        const ret = node.runXpath("Solicitor/ContactPeople[@MainContact='1']/@ContactName");
        return ret;
    }
    getPropertyAddress(): string {
        let node = this.livedataRoot as any;
        const ret = node.runXpath("Property/@PropertyAddress");
        return ret;
    }
}

export function getProvinceFullName(provinceShort: string): string {
    const provinceMap: Record<string, string> = {
        'BC': 'British Columbia',
        'ON': 'Ontario',
        'AB': 'Alberta',
        'MB': 'Manitoba',
        'SK': 'Saskatchewan',
        'NS': 'Nova Scotia'
    };
    
    return provinceMap[provinceShort?.toUpperCase()] || provinceShort;
}

/**
 * Gets the document saving preference from the livedataRoot XML
 * @param livedataRoot - The XML document root element
 * @returns The document saving preference: 'MyDrive', 'Local', 'Download', or 'Cloud'
 */
export function getDocumentSavingPreference(livedataRoot: Element | undefined): DocumentSavingPreferenceType {
    if (!livedataRoot) return 'MyDrive'; // Default
    
    const lawyerNode = (livedataRoot as any).selectSingleNode('lawyer');
    if (!lawyerNode) return 'MyDrive'; // Default
    
    const saveToHardDisk = lawyerNode.getAttribute('SaveToHardDisk') === '1';
    const saveUsingDownload = lawyerNode.getAttribute('SaveUsingDownload') === '1';
    const saveToUserCloud = lawyerNode.getAttribute('SaveMergeDocMode') === "SaveToUserCloud";
    
    if (saveToHardDisk && !saveUsingDownload) {
        return 'Specific Network'; // Specific Network
    } else if (!saveToHardDisk && saveUsingDownload) {
        return 'Download Only'; // Download Only
    } else if (!saveToHardDisk && !saveUsingDownload && !saveToUserCloud) {
        return 'MyDrive'; // MyDrive (default)
    } else if (saveToUserCloud) {
        return 'External Cloud Storage'; // External Cloud Storage
    } else {
        return 'MyDrive'; // MyDrive (default)
    }
}